export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const CasinoGames = {
  roulettetab: {
    slide1: {
      AutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      CricketAutoRoulette: {
        redirectUrl: "/casino/ezg-cricket-auto-roulette",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/cricketautoroulette.jpg",
        alt: "",
        name: "Cricket Auto Roulette",
        providerName: "Ezugi",
      },
      DiamondRouletteEzugi: {
        redirectUrl: "/casino/ezg-diamond-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRouletteEzugi: {
        redirectUrl: "/casino/ezg-namaste-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/NamasteRoulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-speed-auto-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Ezugi",
      },
    
      UltimateRoulette: {
        redirectUrl: "/casino/ezg-ultimate-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateroulette.jpg",
        alt: "",
        name: "Ultimate Roulette",
        providerName: "Ezugi",
      },
      CasinoMarinaRoulette: {
        redirectUrl: "/casino/ezg-casino-marina-roulette-1",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette.jpg",
        alt: "",
        name: "Casino Marina Roulette",
        providerName: "Ezugi",
      },
      CasinoMarina2Roulette: {
        redirectUrl: "/casino/ezg-casino-marina-roulette-2",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette2.jpg",
        alt: "",
        name: "Casino Marina Roulette 2",
        providerName: "Ezugi",
      },

      ItalianRouletteEzugi: {
        redirectUrl: "/casino/ezg-italian-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/ItalianRoulette.jpg",
        alt: "",
        name: "Italian Roulette",
        providerName: "Ezugi",
      },

      Oracle360RouletteEzugi: {
        redirectUrl: "/casino/ezg-oracle-360-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/OracleRoulette360.jpg",
        alt: "",
        name: "Oracle 360 Roulette",
        providerName: "Ezugi",
      },

      PrestigeAutoRoulette2Ezugi: {
        redirectUrl: "/casino/ezg-prestige-auto-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/PrestigeAutoRoulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      RuletadelSolEzugi: {
        redirectUrl: "/casino/ezg-ruleta-del-sol",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/RuletadelSol.jpg",
        alt: "",
        name: "Ruleta del Sol",
        providerName: "Ezugi",
      },
      RussianRouletteEzugi: {
        redirectUrl: "/casino/ezg-russian-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/RussianRoulette.jpg",
        alt: "",
        name: "Russian Roulette",
        providerName: "Ezugi",
      },
      SpanishRouletteEzugi: {
        redirectUrl: "/casino/ezg-spanish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/SpanishRoulette.jpg",
        alt: "",
        name: "Spanish Roulette",
        providerName: "Ezugi",
      },
      TurkishRouletteEzugi: {
        redirectUrl: "/casino/ezg-turkish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/TurkishRoulette.jpg",
        alt: "",
        name: "Turkish Roulette",
        providerName: "Ezugi",
      },
      TurkishRouletteEzugi: {
        redirectUrl: "/casino/ezg-turkish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/TurkishRoulette.jpg",
        alt: "",
        name: "Turkish Roulette",
        providerName: "Ezugi",
      },
    },

    slide2: {
      XXXtremeLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/XXXtremeLightningRoulette.jpg",
        alt: "",
        name: "XXXtreme Lightning Roulette",
        providerName: "Evolution",
      },
      InstantRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-instant-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/InstantRoulette.jpg",
        alt: "",
        name: "Instant Roulette",
        providerName: "Evolution",
      },
      SpeedAutoRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-speed-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      AmericanRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-american-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/AmericanRoulette.jpg",
        alt: "",
        name: "	American Roulette",
        providerName: "Evolution",
      },
      ImmersiveRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-immersive-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/ImmersiveRoulette.jpg",
        alt: "",
        name: "	Immersive Roulette",
        providerName: "Evolution",
      },
      VIPRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-vip-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/VIPRoulette.jpg",
        alt: "",
        name: "	VIP Roulette",
        providerName: "Evolution",
      },
      FootballStudioRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-football-studio-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/footballstudioroulette.jpg",
        alt: "",
        name: "Football Studio Roulette",
        providerName: "Evolution",
      },
      SpeedAutoRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-speed-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      LightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/LightningRoulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      SpeedEvolution: {
        redirectUrl: "/casino/ezgevo-speed-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedRoulette.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      DoubleBallRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-double-ball-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/DoubleBallRoulette.jpg",
        alt: "",
        name: "Double Ball Roulette",
        providerName: "Evolution",
      },
      SalonPriveRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-salon-prive-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SalonPrivatRoulette.jpg",
        alt: "",
        name: "Salon Privé Roulette",
        providerName: "Evolution",
      },
      DragonaraRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-dragonara-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/DragonaraRoulette.jpg",
        alt: "",
        name: "Dragonara Roulette",
        providerName: "Evolution",
      },
      TurkishLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/TurkishLightningRulet.jpg",
        alt: "",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
      FirstPersonAmericanRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-american-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonAmericanRoulette.jpg",
        alt: "",
        name: "First Person American Roulette",
        providerName: "Evolution",
      },
      FirstPersonLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonLightningRoulette.jpg",
        alt: "",
        name: "First Person Lightning Roulette",
        providerName: "Evolution",
      },
      FirstPersonRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonRoulette.jpg",
        alt: "",
        name: "First Person Roulette",
        providerName: "Evolution",
      },
    },

    name: "Roulette",
    key: "Roulette",
  },
  roulettepage: {
    slide1: {
      AutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      CricketAutoRoulette: {
        redirectUrl: "/casino/ezg-cricket-auto-roulette",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/cricketautoroulette.jpg",
        alt: "",
        name: "Cricket Auto Roulette",
        providerName: "Ezugi",
      },
      DiamondRouletteEzugi: {
        redirectUrl: "/casino/ezg-diamond-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRouletteEzugi: {
        redirectUrl: "/casino/ezg-namaste-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/NamasteRoulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-speed-auto-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Ezugi",
      },
      
      UltimateRoulette: {
        redirectUrl: "/casino/ezg-ultimate-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateroulette.jpg",
        alt: "",
        name: "Ultimate Roulette",
        providerName: "Ezugi",
      },
      CasinoMarinaRoulette: {
        redirectUrl: "/casino/ezg-casino-marina-roulette-1",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette.jpg",
        alt: "",
        name: "Casino Marina Roulette",
        providerName: "Ezugi",
      },
      CasinoMarina2Roulette: {
        redirectUrl: "/casino/ezg-casino-marina-roulette-2",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette2.jpg",
        alt: "",
        name: "Casino Marina Roulette 2",
        providerName: "Ezugi",
      },

      ItalianRouletteEzugi: {
        redirectUrl: "/casino/ezg-italian-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/ItalianRoulette.jpg",
        alt: "",
        name: "Italian Roulette",
        providerName: "Ezugi",
      },
      OracleBlazeRouletteEzugi: {
        redirectUrl: "/casino/ezg-oracle-blaze-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/OracleBlaze.jpg",
        alt: "",
        name: "Oracle Blaze Roulette",
        providerName: "Ezugi",
      },

      Oracle360RouletteEzugi: {
        redirectUrl: "/casino/ezg-oracle-360-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/OracleRoulette360.jpg",
        alt: "",
        name: "Oracle 360 Roulette",
        providerName: "Ezugi",
      },

      PortomasoRealCasinoRoulette2Ezugi: {
        redirectUrl: "/casino/ezg-portomaso-roulette-2",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/PortomasoRealCasinoRoulette2.jpg",
        alt: "",
        name: "Portomaso Real Casino Roulette 2",
        providerName: "Ezugi",
      },
      PrestigeAutoRoulette2Ezugi: {
        redirectUrl: "/casino/ezg-prestige-auto-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/PrestigeAutoRoulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      RuletadelSolEzugi: {
        redirectUrl: "/casino/ezg-ruleta-del-sol",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/RuletadelSol.jpg",
        alt: "",
        name: "Ruleta del Sol",
        providerName: "Ezugi",
      },
      RussianRouletteEzugi: {
        redirectUrl: "/casino/ezg-russian-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/RussianRoulette.jpg",
        alt: "",
        name: "Russian Roulette",
        providerName: "Ezugi",
      },
      SpanishRouletteEzugi: {
        redirectUrl: "/casino/ezg-spanish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/SpanishRoulette.jpg",
        alt: "",
        name: "Spanish Roulette",
        providerName: "Ezugi",
      },
      TurkishRouletteEzugi: {
        redirectUrl: "/casino/ezg-turkish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/TurkishRoulette.jpg",
        alt: "",
        name: "Turkish Roulette",
        providerName: "Ezugi",
      },
      TurkishRouletteEzugi: {
        redirectUrl: "/casino/ezg-turkish-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/ezugi/TurkishRoulette.jpg",
        alt: "",
        name: "Turkish Roulette",
        providerName: "Ezugi",
      },
    },

    slide2: {
      XXXtremeLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/XXXtremeLightningRoulette.jpg",
        alt: "",
        name: "XXXtreme Lightning Roulette",
        providerName: "Evolution",
      },
      InstantRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-instant-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/InstantRoulette.jpg",
        alt: "",
        name: "Instant Roulette",
        providerName: "Evolution",
      },
      SpeedAutoRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-speed-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      AmericanRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-american-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/AmericanRoulette.jpg",
        alt: "",
        name: "	American Roulette",
        providerName: "Evolution",
      },
      ImmersiveRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-immersive-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/ImmersiveRoulette.jpg",
        alt: "",
        name: "	Immersive Roulette",
        providerName: "Evolution",
      },
      VIPRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-vip-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/VIPRoulette.jpg",
        alt: "",
        name: "	VIP Roulette",
        providerName: "Evolution",
      },
      FootballStudioRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-football-studio-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/footballstudioroulette.jpg",
        alt: "",
        name: "Football Studio Roulette",
        providerName: "Evolution",
      },
      SpeedAutoRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-speed-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      LightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/LightningRoulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      SpeedEvolution: {
        redirectUrl: "/casino/ezgevo-speed-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SpeedRoulette.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      DoubleBallRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-double-ball-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/DoubleBallRoulette.jpg",
        alt: "",
        name: "Double Ball Roulette",
        providerName: "Evolution",
      },
      SalonPriveRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-salon-prive-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/SalonPrivatRoulette.jpg",
        alt: "",
        name: "Salon Privé Roulette",
        providerName: "Evolution",
      },
      DragonaraRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-dragonara-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/DragonaraRoulette.jpg",
        alt: "",
        name: "Dragonara Roulette",
        providerName: "Evolution",
      },
      TurkishLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/TurkishLightningRulet.jpg",
        alt: "",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
      FirstPersonAmericanRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-american-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonAmericanRoulette.jpg",
        alt: "",
        name: "First Person American Roulette",
        providerName: "Evolution",
      },
      FirstPersonLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonLightningRoulette.jpg",
        alt: "",
        name: "First Person Lightning Roulette",
        providerName: "Evolution",
      },
      FirstPersonRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/evolution/FirstPersonRoulette.jpg",
        alt: "",
        name: "First Person Roulette",
        providerName: "Evolution",
      },
    },

    slide3: {},

    slide4: {
      oracle360rouletteVivo: {
        redirectUrl: "/casino/vivo-oracle-360-roulette",
        imgUrl: "./images/vivo/roulette/oracle360roulette.jpg",
        name: "Oracle 360 Roulette",
        providerName: "Vivo",
      },
      EuropeanAutoRoulette: {
        redirectUrl: "/casino/vivo-european-auto-roulette",
        imgUrl: "./images/vivo/roulette/EuropeanAutoRoulette.jpg",
        name: "European Auto Roulette",
        providerName: "Vivo",
      },
      OracleBlazeRoulette: {
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        imgUrl: "./images/vivo/blackjack/OceaniaVIPBlackjack.jpg",
        name: "Oracle Blaze Roulette",
        providerName: "Vivo",
      },
      LasVegasRoulette: {
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        imgUrl: "./images/vivo/roulette/LasVegasRoulette.jpg",
        name: "Las Vegas Roulette",
        providerName: "Vivo",
      },
      PortomasoRoulette: {
        redirectUrl: "/casino/vivo-portomaso-roulette",
        imgUrl: "./images/vivo/roulette/PortomasoRoulette.jpg",
        name: "Portomaso Roulette",
        providerName: "Vivo",
      },
      OrientalRoulette: {
        redirectUrl: "/casino/vivo-oriental-roulette",
        imgUrl: "./images/vivo/roulette/OrientalRoulette.jpg",
        name: "Oriental Roulette",
        providerName: "Vivo",
      },
      OracleBlazeRouletteVivo: {
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        imgUrl: "./images/vivo/roulette/OracleBlazeRoulette.jpg",
        name: "Oracle Blaze Roulette",
        providerName: "Vivo",
      },
      VARouletteVivo: {
        redirectUrl: "/casino/vivo-va-roulette",
        imgUrl: "./images/vivo/roulette/VARoulette.jpg",
        name: "VA Roulette",
        providerName: "Vivo",
      },
    },
    name: "Roulette",
    key: "roulettepage",
  },
  baccarattab: {
    slide1: {
      BaccaratEzugi: {
        redirectUrl: "/casino/ezg-baccarat",
        code: "1000141",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Ezugi",
      },
      CricketWar: {
        redirectUrl: "/casino/ezg-cricket-war",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CricketWar.jpg",
        alt: "",
        name: "Cricket War",
        providerName: "Ezugi",
      },

      FortuneBaccaratEzugi: {
        redirectUrl: "/casino/ezg-fortune-baccarat",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/FortuneBaccarat.jpg",
        alt: "",
        name: "Fortune Baccarat",
        providerName: "Ezugi",
      },

      DragonTigerEzugi: {
        redirectUrl: "/casino/ezg-dragon-tiger",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat1Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-1",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.jpg",
        alt: "",
        name: "Casino Marina Baccarat 1",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat2Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-2",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.jpg",
        alt: "",
        name: "Casino Marina Baccarat 2",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat3Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-3",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.jpg",
        alt: "",
        name: "Casino Marina Baccarat 3",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat4Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-4",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.jpg",
        alt: "",
        name: "Casino Marina Baccarat 4",
        providerName: "Ezugi",
      },
      BaccaratSuper6Ezugi: {
        redirectUrl: "/casino/ezgevo-super-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/BaccaratSuper6.jpg",
        alt: "",
        name: "Super 6 Baccarat",
        providerName: "Ezugi",
      },

      BaccaratKnockOutEzugi: {
        redirectUrl: "/casino/ezg-knockout-baccarat",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/BaccaratKnockOut.jpg",
        alt: "",
        name: "Baccarat Knockout",
        providerName: "Ezugi",
      },
    },
    slide2: {
      BaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratA.jpg",
        alt: "",
        name: "Baccarat A",
        providerName: "Evolution",
      },
      BaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratB.jpg",
        alt: "",
        name: "Baccarat B",
        providerName: "Evolution",
      },
      BaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratC.jpg",
        alt: "",
        name: "Baccarat C",
        providerName: "Evolution",
      },
      BaccaratControlSqueezeEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-control-squeeze",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratControlSqueeze.jpg",
        alt: "",
        name: "Baccarat Control Squeeze",
        providerName: "Evolution",
      },
      BaccaratSqueezeEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-squeeze",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratSqueeze.jpg",
        alt: "",
        name: "Baccarat Squeeze",
        providerName: "Evolution",
      },
      FirstPersonBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/FirstPersonBaccarat.jpg",
        alt: "",
        name: "First Person Baccarat",
        providerName: "Evolution",
      },
      FirstPersonGoldenWealthBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-golden-wealth-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl:
          "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.jpg",
        alt: "",
        name: "First Person Golden Wealth Baccarat",
        providerName: "Evolution",
      },
      FirstPersonLightningBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-lightning-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/FirstPersonLightningBaccarat.jpg",
        alt: "",
        name: "First Person Lightning Baccarat",
        providerName: "Evolution",
      },
      GoldenWealthBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-golden-wealth-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/GoldenWealthBaccarat.jpg",
        alt: "",
        name: "Golden Wealth Baccarat",
        providerName: "Evolution",
      },
      LightningBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/LightningBaccarat.jpg",
        alt: "",
        name: "Lightning Baccarat",
        providerName: "Evolution",
      },

      NoCommSpeedBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratA.jpg",
        alt: "",
        name: "No Commission Speed Baccarat A",
        providerName: "Evolution",
      },
      NoCommSpeedBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratB.jpg",
        alt: "",
        name: "No Commission Speed Baccarat B",
        providerName: "Evolution",
      },
      NoCommSpeedBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratC.jpg",
        alt: "",
        name: "No Commission Speed Baccarat C",
        providerName: "Evolution",
      },
      SalonPrivateBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivateBaccaratA.jpg",
        alt: "",
        name: "Salon Priv Baccarat A",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratB.jpg",
        alt: "",
        name: "Salon Priv Baccarat B",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratC.jpg",
        alt: "",
        name: "Salon Priv Baccarat C",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratDEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-d",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratD.jpg",
        alt: "",
        name: "Salon Priv Baccarat D",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratEEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-e",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratE.jpg",
        alt: "",
        name: "Salon Priv Baccarat E",
        providerName: "Evolution",
      },
      SpeedBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratA.jpg",
        alt: "",
        name: "Speed Baccarat A",
        providerName: "Evolution",
      },
      SpeedBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratB.jpg",
        alt: "",
        name: "Speed Baccarat B",
        providerName: "Evolution",
      },
      SpeedBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratC.jpg",
        alt: "",
        name: "Speed Baccarat C",
        providerName: "Evolution",
      },
      SpeedBaccaratDEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-d",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratD.jpg",
        alt: "",
        name: "Speed Baccarat D",
        providerName: "Evolution",
      },
      SpeedBaccaratEEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-e",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratE.jpg",
        alt: "",
        name: "Speed Baccarat E",
        providerName: "Evolution",
      },
      SpeedBaccaratFEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-f",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratF.jpg",
        alt: "",
        name: "Speed Baccarat F",
        providerName: "Evolution",
      },
      SpeedBaccaratGEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-g",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratG.jpg",
        alt: "",
        name: "Speed Baccarat G",
        providerName: "Evolution",
      },
      SpeedBaccaratHEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-h",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratH.jpg",
        alt: "",
        name: "Speed Baccarat H",
        providerName: "Evolution",
      },
      SpeedBaccaratIEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-i",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratI.jpg",
        alt: "",
        name: "Speed Baccarat I",
        providerName: "Evolution",
      },
      SpeedBaccaratJEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-j",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratJ.jpg",
        alt: "",
        name: "Speed Baccarat J",
        providerName: "Evolution",
      },
      SpeedBaccaratKEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-k",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratK.jpg",
        alt: "",
        name: "Speed Baccarat K",
        providerName: "Evolution",
      },
      SpeedBaccaratLEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-l",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratL.jpg",
        alt: "",
        name: "Speed Baccarat L",
        providerName: "Evolution",
      },
      SpeedBaccaratMEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-m",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratM.jpg",
        alt: "",
        name: "Speed Baccarat M",
        providerName: "Evolution",
      },
      SpeedBaccaratNEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-n",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratN.jpg",
        alt: "",
        name: "Speed Baccarat N",
        providerName: "Evolution",
      },
      SpeedBaccaratOEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-o",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratO.jpg",
        alt: "",
        name: "Speed Baccarat O",
        providerName: "Evolution",
      },
      SpeedBaccaratPEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-p",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratP.jpg",
        alt: "",
        name: "Speed Baccarat P",
        providerName: "Evolution",
      },
      SpeedBaccaratQEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-q",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratQ.jpg",
        alt: "",
        name: "Speed Baccarat Q",
        providerName: "Evolution",
      },
      SpeedBaccaratREvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-r",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratR.jpg",
        alt: "",
        name: "Speed Baccarat R",
        providerName: "Evolution",
      },
      SpeedBaccaratSEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-s",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratS.jpg",
        alt: "",
        name: "Speed Baccarat S",
        providerName: "Evolution",
      },
    },

    name: "Baccarat",
    key: "Baccarat",
  },
  baccaratpage: {
    slide1: {
      BaccaratEzugi: {
        redirectUrl: "/casino/ezg-baccarat",
        code: "1000141",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Ezugi",
      },
      CricketWar: {
        redirectUrl: "/casino/ezg-cricket-war",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CricketWar.jpg",
        alt: "",
        name: "Cricket War",
        providerName: "Ezugi",
      },

      FortuneBaccaratEzugi: {
        redirectUrl: "/casino/ezg-fortune-baccarat",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/FortuneBaccarat.jpg",
        alt: "",
        name: "Fortune Baccarat",
        providerName: "Ezugi",
      },

      DragonTigerEzugi: {
        redirectUrl: "/casino/ezg-dragon-tiger",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat1Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-1",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.jpg",
        alt: "",
        name: "Casino Marina Baccarat 1",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat2Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-2",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.jpg",
        alt: "",
        name: "Casino Marina Baccarat 2",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat3Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-3",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.jpg",
        alt: "",
        name: "Casino Marina Baccarat 3",
        providerName: "Ezugi",
      },
      CasinoMarinaBaccarat4Ezugi: {
        redirectUrl: "/casino/ezg-casino-marina-baccarat-4",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.jpg",
        alt: "",
        name: "Casino Marina Baccarat 4",
        providerName: "Ezugi",
      },
      BaccaratSuper6Ezugi: {
        redirectUrl: "/casino/ezgevo-super-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/BaccaratSuper6.jpg",
        alt: "",
        name: "Super 6 Baccarat",
        providerName: "Ezugi",
      },

      BaccaratKnockOutEzugi: {
        redirectUrl: "/casino/ezg-knockout-baccarat",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/ezugi/BaccaratKnockOut.jpg",
        alt: "",
        name: "Baccarat Knockout",
        providerName: "Ezugi",
      },
    },
    slide2: {
      BaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratA.jpg",
        alt: "",
        name: "Baccarat A",
        providerName: "Evolution",
      },
      BaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratB.jpg",
        alt: "",
        name: "Baccarat B",
        providerName: "Evolution",
      },
      BaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratC.jpg",
        alt: "",
        name: "Baccarat C",
        providerName: "Evolution",
      },
      BaccaratControlSqueezeEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-control-squeeze",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratControlSqueeze.jpg",
        alt: "",
        name: "Baccarat Control Squeeze",
        providerName: "Evolution",
      },
      BaccaratSqueezeEvolution: {
        redirectUrl: "/casino/ezgevo-baccarat-squeeze",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/BaccaratSqueeze.jpg",
        alt: "",
        name: "Baccarat Squeeze",
        providerName: "Evolution",
      },
      FirstPersonBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/FirstPersonBaccarat.jpg",
        alt: "",
        name: "First Person Baccarat",
        providerName: "Evolution",
      },
      FirstPersonGoldenWealthBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-golden-wealth-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl:
          "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.jpg",
        alt: "",
        name: "First Person Golden Wealth Baccarat",
        providerName: "Evolution",
      },
      FirstPersonLightningBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-lightning-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/FirstPersonLightningBaccarat.jpg",
        alt: "",
        name: "First Person Lightning Baccarat",
        providerName: "Evolution",
      },
      GoldenWealthBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-golden-wealth-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/GoldenWealthBaccarat.jpg",
        alt: "",
        name: "Golden Wealth Baccarat",
        providerName: "Evolution",
      },
      LightningBaccaratEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-baccarat",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/LightningBaccarat.jpg",
        alt: "",
        name: "Lightning Baccarat",
        providerName: "Evolution",
      },

      NoCommSpeedBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratA.jpg",
        alt: "",
        name: "No Commission Speed Baccarat A",
        providerName: "Evolution",
      },
      NoCommSpeedBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratB.jpg",
        alt: "",
        name: "No Commission Speed Baccarat B",
        providerName: "Evolution",
      },
      NoCommSpeedBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-no-commission-speed-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/NoCommSpeedBaccaratC.jpg",
        alt: "",
        name: "No Commission Speed Baccarat C",
        providerName: "Evolution",
      },
      SalonPrivateBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivateBaccaratA.jpg",
        alt: "",
        name: "Salon Priv Baccarat A",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratB.jpg",
        alt: "",
        name: "Salon Priv Baccarat B",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratC.jpg",
        alt: "",
        name: "Salon Priv Baccarat C",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratDEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-d",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratD.jpg",
        alt: "",
        name: "Salon Priv Baccarat D",
        providerName: "Evolution",
      },
      SalonPrivatBaccaratEEvolution: {
        redirectUrl: "/casino/ezgevo-salon-priv-baccarat-e",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SalonPrivatBaccaratE.jpg",
        alt: "",
        name: "Salon Priv Baccarat E",
        providerName: "Evolution",
      },
      SpeedBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-a",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratA.jpg",
        alt: "",
        name: "Speed Baccarat A",
        providerName: "Evolution",
      },
      SpeedBaccaratBEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-b",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratB.jpg",
        alt: "",
        name: "Speed Baccarat B",
        providerName: "Evolution",
      },
      SpeedBaccaratCEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-c",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratC.jpg",
        alt: "",
        name: "Speed Baccarat C",
        providerName: "Evolution",
      },
      SpeedBaccaratDEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-d",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratD.jpg",
        alt: "",
        name: "Speed Baccarat D",
        providerName: "Evolution",
      },
      SpeedBaccaratEEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-e",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratE.jpg",
        alt: "",
        name: "Speed Baccarat E",
        providerName: "Evolution",
      },
      SpeedBaccaratFEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-f",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratF.jpg",
        alt: "",
        name: "Speed Baccarat F",
        providerName: "Evolution",
      },
      SpeedBaccaratGEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-g",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratG.jpg",
        alt: "",
        name: "Speed Baccarat G",
        providerName: "Evolution",
      },
      SpeedBaccaratHEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-h",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratH.jpg",
        alt: "",
        name: "Speed Baccarat H",
        providerName: "Evolution",
      },
      SpeedBaccaratIEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-i",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratI.jpg",
        alt: "",
        name: "Speed Baccarat I",
        providerName: "Evolution",
      },
      SpeedBaccaratJEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-j",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratJ.jpg",
        alt: "",
        name: "Speed Baccarat J",
        providerName: "Evolution",
      },
      SpeedBaccaratKEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-k",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratK.jpg",
        alt: "",
        name: "Speed Baccarat K",
        providerName: "Evolution",
      },
      SpeedBaccaratLEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-l",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratL.jpg",
        alt: "",
        name: "Speed Baccarat L",
        providerName: "Evolution",
      },
      SpeedBaccaratMEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-m",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratM.jpg",
        alt: "",
        name: "Speed Baccarat M",
        providerName: "Evolution",
      },
      SpeedBaccaratNEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-n",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratN.jpg",
        alt: "",
        name: "Speed Baccarat N",
        providerName: "Evolution",
      },
      SpeedBaccaratOEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-o",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratO.jpg",
        alt: "",
        name: "Speed Baccarat O",
        providerName: "Evolution",
      },
      SpeedBaccaratPEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-p",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratP.jpg",
        alt: "",
        name: "Speed Baccarat P",
        providerName: "Evolution",
      },
      SpeedBaccaratQEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-q",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratQ.jpg",
        alt: "",
        name: "Speed Baccarat Q",
        providerName: "Evolution",
      },
      SpeedBaccaratREvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-r",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratR.jpg",
        alt: "",
        name: "Speed Baccarat R",
        providerName: "Evolution",
      },
      SpeedBaccaratSEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-s",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SpeedBaccaratS.jpg",
        alt: "",
        name: "Speed Baccarat S",
        providerName: "Evolution",
      },
    },
    slide3: {
      MacauBaccaratVivo: {
        redirectUrl: "/casino/vivo-macau-baccarat",
        imgUrl: "./images/vivo/baccarat/MacauBaccarat.jpg",
        name: "Macau Baccarat",
        providerName: "Vivo",
      },
      VABacarat2: {
        redirectUrl: "/casino/vivo-va-bacarat-2",
        imgUrl: "./images/vivo/baccarat/VABacarat2.jpg",
        name: "VA Bacarat 2",
        providerName: "Vivo",
      },
      VABacarat3: {
        redirectUrl: "/casino/vivo-va-bacarat-3",
        imgUrl: "./images/vivo/baccarat/VABacarat3.jpg",
        name: "VA Bacarat 3",
        providerName: "Vivo",
      },
      VABacarat4: {
        redirectUrl: "/casino/vivo-va-bacarat-4",
        imgUrl: "./images/vivo/baccarat/VABacarat4.jpg",
        name: "VA Bacarat 4",
        providerName: "Vivo",
      },
      VABacarat5: {
        redirectUrl: "/casino/vivo-va-bacarat-5",
        imgUrl: "./images/vivo/baccarat/VABacarat5.jpg",
        name: "VA Bacarat 5",
        providerName: "Vivo",
      },
      GalaxyBaccarat1Vivo: {
        redirectUrl: "/casino/vivo-galaxy-baccarat-1",
        imgUrl: "./images/vivo/baccarat/GalaxyBaccarat1.jpg",
        name: "Galaxy Baccarat 1",
        providerName: "Vivo",
      },
    },
    slide4: {
      BaccaratSupernowa: {
        redirectUrl: "/casino/sn-baccarat",
        code: "ABC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Supernowa",
      },
      RNGBaccaratSupernowa: {
        redirectUrl: "/casino/sn-rng-baccarat",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGBaccarat.jpg",
        alt: "",
        name: "RNG Baccarat",
        providerName: "Supernowa",
      },
    },
    name: "baccaratpage",
    key: "baccaratpage",
  },
  Blackjacktab: {
    slide1: {
      FiestaUnlimitedBlackjackEzugi: {
        redirectUrl: "/casino/ezg-fiesta-unlimited-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/FiestaBlackjackUnlimited.jpg",
        alt: "",
        name: "	Fiesta Unlimited Blackjack",
        providerName: "Ezugi",
      },
      TurkishUnlimitedBlackjackEzugi: {
        redirectUrl: "/casino/ezg-turkish-unlimited-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/UnlimitedTurkishBlackjack.jpg",
        alt: "",
        name: "	Unlimited Turkish Blackjack",
        providerName: "Ezugi",
      },
      TurkishBlackjackEzugi: {
        redirectUrl: "/casino/ezg-turkish-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/TurkishBlackjack.jpg",
        alt: "",
        name: "Turkish Blackjack",
        providerName: "Ezugi",
      },
      TurkishBlackjack1Ezugi: {
        redirectUrl: "/casino/ezg-turkish-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/TurkishBlackjack1.jpg",
        alt: "",
        name: "Turkish Blackjack 1",
        providerName: "Ezugi",
      },
      TurkishBlackjack2Ezugi: {
        redirectUrl: "/casino/ezg-turkish-blackjack-2",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/TurkishBlackjack2.jpg",
        alt: "",
        name: "Turkish Blackjack 2",
        providerName: "Ezugi",
      },
      RumbaBlackjack1Ezugi: {
        redirectUrl: "/casino/ezg-rumba-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/RumbaBlackjack1.jpg",
        alt: "",
        name: "Rumba Blackjack 1",
        providerName: "Ezugi",
      },
      RumbaBlackjack4Ezugi: {
        redirectUrl: "/casino/ezg-rumba-blackjack-4",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/RumbaBlackjack4.jpg",
        alt: "",
        name: "Rumba Blackjack 4",
        providerName: "Ezugi",
      },
      RussianBlackjack2Ezugi: {
        redirectUrl: "/casino/ezg-russian-blackjack-2",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/RussianBlackjack2.jpg",
        alt: "",
        name: "Russian Blackjack 2",
        providerName: "Ezugi",
      },
      SpanishUnlimitedBlackjackEzugi: {
        redirectUrl: "/casino/ezg-spanish-unlimited-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/SpanishUnlimitedBlackjack.jpg",
        alt: "",
        name: "Spanish Unlimited Blackjack",
        providerName: "Ezugi",
      },
      VIPDiamondBlackjackEzugi: {
        redirectUrl: "/casino/ezg-vip-diamond-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/VIPDiamondBlackjack.jpg",
        alt: "",
        name: "VIP Diamond Blackjack",
        providerName: "Ezugi",
      },
      RussianBlackjack1Ezugi: {
        redirectUrl: "/casino/ezg-russian-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/RussianBlackjack1.jpg",
        alt: "",
        name: "Russian Blackjack 1",
        providerName: "Ezugi",
      },
      RussianBlackjack1Ezugi: {
        redirectUrl: "/casino/ezg-russian-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/RussianBlackjack1.jpg",
        alt: "",
        name: "Russian Blackjack 1",
        providerName: "Ezugi",
      },
      ItalianBlackjackEzugi: {
        redirectUrl: "/casino/ezg-italian-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/ItalianBlackjack.jpg",
        alt: "",
        name: "Italian Blackjack",
        providerName: "Ezugi",
      },
      Goldblackjack4Ezugi: {
        redirectUrl: "/casino/ezg-gold-blackjack-4",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/goldblackjack4.jpg",
        alt: "",
        name: "Gold Blackjack 4",
        providerName: "Ezugi",
      },
      Goldblackjack6Ezugi: {
        redirectUrl: "/casino/ezg-gold-blackjack-6",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/goldblackjack6.jpg",
        alt: "",
        name: "Gold Blackjack 6",
        providerName: "Ezugi",
      },
      Goldblackjack5Ezugi: {
        redirectUrl: "/casino/ezg-gold-blackjack-5",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/goldblackjack5.jpg",
        alt: "",
        name: "Gold Blackjack 5",
        providerName: "Ezugi",
      },
      SalonPriveBlackjack5Ezugi: {
        redirectUrl: "/casino/ezg-salon-prive-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/SalonPriveBlackjack.jpg",
        alt: "",
        name: "Salon Prive Blackjack",
        providerName: "Ezugi",
      },
      goldBlackjack3Ezugi: {
        redirectUrl: "/casino/ezg-gold-blackjack-3",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/ezugi/goldblackjack3.jpg",
        alt: "",
        name: "Gold Blackjack 3",
        providerName: "Ezugi",
      },
    },

    slide2: {
      InfiniteBlackjackEvolution: {
        redirectUrl: "/casino/ezgevo-infinite-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/InfiniteBlackjack.jpg",
        alt: "",
        name: "	Infinite Blackjack",
        providerName: "Evolution",
      },
      // FreeBetBlackjackEvolution: {
      //   redirectUrl: "/casino/ezgevo-free-bet-blackjack",
      //   code: "1000148",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/ezugi"),
      //   imgUrl: "./images/blackjack/evolution/FreeBetBlackjack.jpg",
      //   alt: "",
      //   name: "Free Bet Blackjack",
      //   providerName: "Evolution",
      // },
      FreeBetBlackjack1Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack1.jpg",
        alt: "",
        name: "Free Bet Blackjack 1",
        providerName: "Evolution",
      },
      FreeBetBlackjack2Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-2",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack2.jpg",
        alt: "",
        name: "Free Bet Blackjack 2",
        providerName: "Evolution",
      },
      FreeBetBlackjack3Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-3",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack4.jpg",
        alt: "",
        name: "Free Bet Blackjack 3",
        providerName: "Evolution",
      },
      FreeBetBlackjack4Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-4",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack4.jpg",
        alt: "",
        name: "Free Bet Blackjack 4",
        providerName: "Evolution",
      },
      FreeBetBlackjack5Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-5",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack5.jpg",
        alt: "",
        name: "Free Bet Blackjack 5",
        providerName: "Evolution",
      },
      FreeBetBlackjack6Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-6",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack6.jpg",
        alt: "",
        name: "Free Bet Blackjack 6",
        providerName: "Evolution",
      },
      FreeBetBlackjack7Evolution: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-7",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/freebetblackjack7.jpg",
        alt: "",
        name: "Free Bet Blackjack 7",
        providerName: "Evolution",
      },
      PowerBlackjackEvolution: {
        redirectUrl: "/casino/ezgevo-power-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/PowerBlackjack.jpg",
        alt: "",
        name: "Power Blackjack",
        providerName: "Evolution",
      },
      LightningBlackjackEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/light.jpg",
        alt: "",
        name: "Lightning Blackjack",
        providerName: "Evolution",
      },
      // CrapsEvolution: {
      //   redirectUrl: "/casino/ezgevo-craps",
      //   code: "1000148",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/ezugi"),
      //   imgUrl: "./images/blackjack/evolution/PowerBlackjack.jpg",
      //   alt: "",
      //   name: "Craps",
      //   providerName: "Evolution",
      // },
      ClassicSpeedBlackjack1Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack1.jpg",
        alt: "",
        name: "Classic Speed Blackjack 1",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack2Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-2",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack2.jpg",
        alt: "",
        name: "Classic Speed Blackjack 2",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack3Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-3",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack3.jpg",
        alt: "",
        name: "Classic Speed Blackjack 3",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack4Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-4",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack4.jpg",
        alt: "",
        name: "Classic Speed Blackjack 4",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack5Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-5",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack5.jpg",
        alt: "",
        name: "Classic Speed Blackjack 5",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack6Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-6",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack6.jpg",
        alt: "",
        name: "Classic Speed Blackjack 6",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack8Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-8",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack8.jpg",
        alt: "",
        name: "Classic Speed Blackjack 8",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack9Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-9",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack9.jpg",
        alt: "",
        name: "Classic Speed Blackjack 9",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack10Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-10",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack10.jpg",
        alt: "",
        name: "Classic Speed Blackjack 10",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack11Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-11",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack11.jpg",
        alt: "",
        name: "Classic Speed Blackjack 11",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack12Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-12",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack12.jpg",
        alt: "",
        name: "Classic Speed Blackjack 12",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack13Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-13",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack13.jpg",
        alt: "",
        name: "Classic Speed Blackjack 13",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack14Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-14",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack14.jpg",
        alt: "",
        name: "Classic Speed Blackjack 14",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack15Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-15",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack15.jpg",
        alt: "",
        name: "Classic Speed Blackjack 15",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack16Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-16",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack16.jpg",
        alt: "",
        name: "Classic Speed Blackjack 16",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack17Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-17",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack17.jpg",
        alt: "",
        name: "Classic Speed Blackjack 17",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack18Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-18",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack18.jpg",
        alt: "",
        name: "Classic Speed Blackjack 18",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack19Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-19",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack19.jpg",
        alt: "",
        name: "Classic Speed Blackjack 19",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack20Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-20",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack20.jpg",
        alt: "",
        name: "Classic Speed Blackjack 20",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack21Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-21",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack21.jpg",
        alt: "",
        name: "Classic Speed Blackjack 21",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack22Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-22",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack22.jpg",
        alt: "",
        name: "Classic Speed Blackjack 22",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack23Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-23",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack23.jpg",
        alt: "",
        name: "Classic Speed Blackjack 23",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack24Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-24",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack24.jpg",
        alt: "",
        name: "Classic Speed Blackjack 24",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack25Evolution: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-25",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack25.jpg",
        alt: "",
        name: "Classic Speed Blackjack 25",
        providerName: "Evolution",
      },
      BlackjackAEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-a",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackA.jpg",
        alt: "",
        name: "Blackjack A",
        providerName: "Evolution",
      },
      BlackjackBEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-b",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackB.jpg",
        alt: "",
        name: "Blackjack B",
        providerName: "Evolution",
      },
      BlackjackCEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-c",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackC.jpg",
        alt: "",
        name: "Blackjack C",
        providerName: "Evolution",
      },
      BlackjackPartyEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-party",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackParty.jpg",
        alt: "",
        name: "Blackjack Party",
        providerName: "Evolution",
      },
      BlackjackSilverAEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-a",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverA.jpg",
        alt: "",
        name: "Blackjack Silver A",
        providerName: "Evolution",
      },
      BlackjackSilverBEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-b",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverB.jpg",
        alt: "",
        name: "Blackjack Silver B",
        providerName: "Evolution",
      },
      BlackjackSilverCEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-c",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverC.jpg",
        alt: "",
        name: "Blackjack Silver C",
        providerName: "Evolution",
      },
      BlackjackSilverDEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-d",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverD.jpg",
        alt: "",
        name: "Blackjack Silver D",
        providerName: "Evolution",
      },
      BlackjackSilverEEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-e",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverE.jpg",
        alt: "",
        name: "Blackjack Silver E",
        providerName: "Evolution",
      },
      BlackjackSilverFEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-f",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverF.jpg",
        alt: "",
        name: "Blackjack Silver F",
        providerName: "Evolution",
      },
      BlackjackSilverGEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-silver-g",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackSilverG.jpg",
        alt: "",
        name: "Blackjack Silver G",
        providerName: "Evolution",
      },
      BlackjackVIP1Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-1",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP1.jpg",
        alt: "",
        name: "Blackjack VIP 1",
        providerName: "Evolution",
      },
      BlackjackVIP2Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-2",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP2.jpg",
        alt: "",
        name: "Blackjack VIP 2",
        providerName: "Evolution",
      },
      BlackjackVIP3Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-3",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP3.jpg",
        alt: "",
        name: "Blackjack VIP 3",
        providerName: "Evolution",
      },
      BlackjackVIP4Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-4",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP4.jpg",
        alt: "",
        name: "Blackjack VIP 4",
        providerName: "Evolution",
      },
      BlackjackVIP5Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-5",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP5.jpg",
        alt: "",
        name: "Blackjack VIP 5",
        providerName: "Evolution",
      },
      BlackjackVIP6Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-6",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP6.jpg",
        alt: "",
        name: "Blackjack VIP 6",
        providerName: "Evolution",
      },
      BlackjackVIP7Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-7",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP7.jpg",
        alt: "",
        name: "Blackjack VIP 7",
        providerName: "Evolution",
      },

      BlackjackVIP8Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-8",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP8.jpg",
        alt: "",
        name: "Blackjack VIP 8",
        providerName: "Evolution",
      },
      BlackjackVIP9Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-9",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP9.jpg",
        alt: "",
        name: "Blackjack VIP 9",
        providerName: "Evolution",
      },
      BlackjackVIP10Evolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-10",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIP10.jpg",
        alt: "",
        name: "Blackjack VIP 10",
        providerName: "Evolution",
      },
      BlackjackVIPAEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-a",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPA.jpg",
        alt: "",
        name: "Blackjack VIP A",
        providerName: "Evolution",
      },
      BlackjackVIPAlphaEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-alpha",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPAlpha.jpg",
        alt: "",
        name: "Blackjack VIP Alpha",
        providerName: "Evolution",
      },
      BlackjackVIPBEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-b",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPB.jpg",
        alt: "",
        name: "Blackjack VIP B",
        providerName: "Evolution",
      },
      BlackjackVIPBetaEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-beta",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPBeta.jpg",
        alt: "",
        name: "Blackjack VIP Beta",
        providerName: "Evolution",
      },
      BlackjackVIPCEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-c",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPC.jpg",
        alt: "",
        name: "Blackjack VIP C",
        providerName: "Evolution",
      },
      BlackjackVIPDEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-d",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPD.jpg",
        alt: "",
        name: "Blackjack VIP D",
        providerName: "Evolution",
      },
      BlackjackVIPEEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-e",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPE.jpg",
        alt: "",
        name: "Blackjack VIP E",
        providerName: "Evolution",
      },
      BlackjackVIPGEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-g",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPG.jpg",
        alt: "",
        name: "Blackjack VIP G",
        providerName: "Evolution",
      },
      BlackjackVIPHEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-h",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPH.jpg",
        alt: "",
        name: "Blackjack VIP H",
        providerName: "Evolution",
      },
      BlackjackVIPGammaEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-gamma",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPGamma.jpg",
        alt: "",
        name: "Blackjack VIP Gamma",
        providerName: "Evolution",
      },
      BlackjackVIPIEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-i",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPI.jpg",
        alt: "",
        name: "Blackjack VIP I",
        providerName: "Evolution",
      },
      BlackjackVIPLEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-l",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPL.jpg",
        alt: "",
        name: "Blackjack VIP L",
        providerName: "Evolution",
      },
      BlackjackVIPMEvolution: {
        redirectUrl: "/casino/ezgevo-blackjack-vip-m",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/BlackjackVIPM.jpg",
        alt: "",
        name: "Blackjack VIP M",
        providerName: "Evolution",
      },
      FirstPersonBlackjackEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/blackjack/evolution/FirstPersonBlackjack.jpg",
        alt: "",
        name: "First Person Blackjack",
        providerName: "Evolution",
      },
      FirstPersonLightningBlackjackEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-lightning-blackjack",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl:
          "./images/blackjack/evolution/FirstPersonLightningBlackjack.jpg",
        alt: "",
        name: "First Person Lightning Blackjack",
        providerName: "Evolution",
      },
    },

    name: "Blackjack",
    key: "Blackjack",
  },
  pokertab: {
    slide1: {
      BetonTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-bet-on-teen-patti",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/BetonTeenPatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      CasinoHoldemEzugi: {
        redirectUrl: "/casino/ezg-casino-holdem",
        code: "150",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CasinoHoldem.jpg",
        alt: "",
        name: "Casino Hold'em",
        providerName: "Ezugi",
      },
      TeenPatti3CardEzugi: {
        redirectUrl: "/casino/ezg-teen-patti-3-card",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/TeenPatti3Card.jpg",
        alt: "",
        name: "Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      OneDayTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-one-day-teen-patti",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/indiangames/ezugi/OneDayTeenPatti.jpg",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
    },
    slide2: {
      Hand2CasinoHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/2HandCasinoHoldem.jpg",
        alt: "",
        name: "2 Hand Casino Holdem",
        providerName: "Evolution",
      },
      CasinoHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-casino-holdem-evo",
        code: "150",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/CasinoHoldem.jpg",
        alt: "",
        name: "Casino Hold'em",
        providerName: "Evolution",
      },
      ThreeCardPokerEvolution: {
        redirectUrl: "/casino/ezgevo-three-card-poker",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/ThreeCardPoker.jpg",
        alt: "",
        name: "Three Card Poker",
        providerName: "Evolution",
      },
      TexasHoldemBonusPokerEvolution: {
        redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/TexasHoldemBonusPoker.jpg",
        alt: "",
        name: "Texas Holdem Bonus Poker",
        providerName: "Evolution",
      },
      UltimateTexasHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-ultimate-texas-holdem",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/UltimateTexasHoldem.jpg",
        alt: "",
        name: "	Ultimate Texas Hold'em",
        providerName: "Evolution",
      },
      SideBetCityEvolution: {
        redirectUrl: "/casino/ezgevo-side-bet-city",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/SideBetCity.jpg",
        alt: "",
        name: "Side Bet City",
        providerName: "Evolution",
      },
    },
    name: "Poker",
    key: "Poker",
  },
  pokerpage: {
    slide1: {
      BetonTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-bet-on-teen-patti",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/BetonTeenPatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      CasinoHoldemEzugi: {
        redirectUrl: "/casino/ezg-casino-holdem",
        code: "150",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CasinoHoldem.jpg",
        alt: "",
        name: "Casino Hold'em",
        providerName: "Ezugi",
      },
      TeenPatti3CardEzugi: {
        redirectUrl: "/casino/ezg-teen-patti-3-card",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/TeenPatti3Card.jpg",
        alt: "",
        name: "Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      OneDayTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-one-day-teen-patti",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/indiangames/ezugi/OneDayTeenPatti.jpg",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
    },
    slide2: {
      Hand2CasinoHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/2HandCasinoHoldem.jpg",
        alt: "",
        name: "2 Hand Casino Holdem",
        providerName: "Evolution",
      },
      CasinoHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-casino-holdem-evo",
        code: "150",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/CasinoHoldem.jpg",
        alt: "",
        name: "Casino Hold'em",
        providerName: "Evolution",
      },
      ThreeCardPokerEvolution: {
        redirectUrl: "/casino/ezgevo-three-card-poker",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/ThreeCardPoker.jpg",
        alt: "",
        name: "Three Card Poker",
        providerName: "Evolution",
      },
      TexasHoldemBonusPokerEvolution: {
        redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/TexasHoldemBonusPoker.jpg",
        alt: "",
        name: "Texas Holdem Bonus Poker",
        providerName: "Evolution",
      },
      UltimateTexasHoldemEvolution: {
        redirectUrl: "/casino/ezgevo-ultimate-texas-holdem",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/UltimateTexasHoldem.jpg",
        alt: "",
        name: "	Ultimate Texas Hold'em",
        providerName: "Evolution",
      },
      SideBetCityEvolution: {
        redirectUrl: "/casino/ezgevo-side-bet-city",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/evolution/SideBetCity.jpg",
        alt: "",
        name: "Side Bet City",
        providerName: "Evolution",
      },
    },
    slide3: {
      PokerSupernowa: {
        redirectUrl: "/casino/sn-poker",
        code: "UD7",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Poker.jpg",
        alt: "",
        name: "Poker",
        providerName: "Supernowa",
      },
      RNG3PlayerTeenPattiSupernowa: {
        redirectUrl: "/casino/sn-rng-3-player-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG3PlayerTeenPatti.jpg",
        alt: "",
        name: "RNG 3 Player Teen Patti",
        providerName: "Supernowa",
      },
      RNGPokerSupernowa: {
        redirectUrl: "/casino/sn-rng-poker",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGPoker.jpg",
        alt: "",
        name: "RNG Poker",
        providerName: "Supernowa",
      },

      RNGTeenPattiSupernowa: {
        redirectUrl: "/casino/sn-rng-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGTeenPatti.jpg",
        alt: "",
        name: "RNG Teen Patti",
        providerName: "Supernowa",
      },
      RNGTeenPatti2020Supernowa: {
        redirectUrl: "/casino/sn-rng-teen-patti-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGTeenPatti2020.jpg",
        alt: "",
        name: "RNG Teen Patti 2020",
        providerName: "Supernowa",
      },
      TeenPattiSupernowa: {
        redirectUrl: "/casino/sn-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti.jpg",
        alt: "",
        name: "Teen Patti",
        providerName: "Supernowa",
      },
      TeenPatti2020Supernowa: {
        redirectUrl: "/casino/sn-teen-patti-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti2020.jpg",
        alt: "",
        name: "Teen Patti 2020",
        providerName: "Supernowa",
      },
      TeenPattiFaceOffSupernowa: {
        redirectUrl: "/casino/sn-teen-patti-face-off",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPattiFaceOff.jpg",
        alt: "",
        name: "Teen Patti Face Off",
        providerName: "Supernowa",
      },
    },
    slide4: {
      CasinoHolemVivo: {
        redirectUrl: "/casino/vivo-casino-holdem",
        imgUrl: "./images/vivo/poker/CasinoHoldem.jpg",
        name: "Casino Hold'em",
        providerName: "Vivo",
      },
    },
    name: "One Day Teen Patti",
    key: "pokerpage",
  },

  dragonSicbotab: {
    slide1: {
      CricketWar: {
        redirectUrl: "/casino/ezg-cricket-war",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CricketWar.jpg",
        alt: "",
        name: "Cricket War",
        providerName: "Ezugi",
      },
      DragonTigerEzugi: {
        redirectUrl: "/casino/ezg-dragon-tiger",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
      UltimateSicBo: {
        redirectUrl: "/casino/ezg-ultimate-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/UltimateSicBo.jpg",
        alt: "",
        name: "Ultimate SicBo",
        providerName: "Ezugi",
      },
      SicBoEzugi: {
        redirectUrl: "/casino/ezg-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/dragonsicbo/ezugi/Sicbo.jpg",
        alt: "",
        name: " SicBo",
        providerName: "Ezugi",
      },
    },
    name: "Dragon Tiger & Sicbo",
    key: "Dragon&Sicbo",
  },
  Sicbotab: {
    slide1: {
      SuperSicBoEvolution: {
        redirectUrl: "/casino/ezgevo-super-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/SuperSicBo.jpg",
        alt: "",
        name: "Super Sic Bo",
        providerName: "Evolution",
      },
      FirstPersonDragonTigerEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-dragon-tiger",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/FirstPersonDragonTiger.jpg",
        alt: "",
        name: "First Person Dragon Tiger",
        providerName: "Evolution",
      },
      DragonTigerEvolution: {
        redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/evolution/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Evolution",
      },
    },
    name: "Sicbo & Dragon Tiger",
    key: "Sicbotab",
  },
  Andarbahartab: {
    slide1: {
      AndarBaharEzugi: {
        redirectUrl: "/casino/ezg-andar-bahar",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/popular/ezugi/AndarBahar.jpg",
        alt: "",
        name: "AndarBahar",
        providerName: "Ezugi",
      },
      UltimateAndarBahar: {
        redirectUrl: "/casino/ezg-ultimate-andar-bahar",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateandarbahar.jpg",
        alt: "",
        name: "Ultimate Andar Bahar",
        providerName: "Ezugi",
      },
      OTTAndarBaharEzugi: {
        redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/indiangames/ezugi/OTTAndarBahar.jpg",
        alt: "",
        name: "OTT Andar Bahar",
        providerName: "Ezugi",
      },
    },
    slide2: {},
    slide3: {
      AndarBaharSupernowa: {
        redirectUrl: "/casino/sn-andar-bahar",
        code: "ARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AndarBahar.jpg",
        alt: "",
        name: "Andar Bahar",
        providerName: "Supernowa",
      },
      ClassicAndarBaharSupernowa: {
        redirectUrl: "/casino/sn-classic-andar-bahar",
        code: "CQ",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/ClassicAndarBahar.jpg",
        alt: "",
        name: "Classic Andar Bahar",
        providerName: "Supernowa",
      },
      GoasAndarBaharSupernowa: {
        redirectUrl: "/casino/sn-goas-andar-bahar",
        code: "DT7M",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/GoasAndarBahar.jpg",
        alt: "",
        name: "Goa's Andar Bahar",
        providerName: "Supernowa",
      },
    },
    slide4: {
      AndarBaharVivo: {
        redirectUrl: "/casino/vivo-andar-bahar",
        imgUrl: "./images/vivo/AndarBahar.jpg",
        name: "Andar Bahar",
        providerName: "Vivo",
      },
    },
    name: "Andar Bahar",
    key: "Andarbahartab",
  },
  spribe: {
    slide1: {
      aviator: {
        redirectUrl: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Aviator.gif",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      mines: {
        redirectUrl: "/casino/spribe/mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/spribe/goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/spribe/dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Dice.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/spribe/plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/spribe/miniroulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Miniroulette.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/spribe/hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/casinopage/Hilo.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },

    name: "Spribe",
  },
  Supernowa: {
    slide1: {
      Cards32Supernowa: {
        redirectUrl: "/casino/sn-32-cards",
        code: "D3TP",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/32Cards.jpg",
        alt: "",
        name: "32 Cards",
        providerName: "Supernowa",
      },
      AkbarRomeoWalterSupernowa: {
        redirectUrl: "/casino/sn-akbar-romeo-walter",
        code: "C32",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AkbarRomeoWalter.jpg",
        alt: "",
        name: "Akbar Romeo Walter",
        providerName: "Supernowa",
      },
      AndarBaharSupernowa: {
        redirectUrl: "/casino/sn-andar-bahar",
        code: "ARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AndarBahar.jpg",
        alt: "",
        name: "Andar Bahar",
        providerName: "Supernowa",
      },
      BaccaratSupernowa: {
        redirectUrl: "/casino/sn-baccarat",
        code: "ABC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Supernowa",
      },

      ClassicAndarBaharSupernowa: {
        redirectUrl: "/casino/sn-classic-andar-bahar",
        code: "CQ",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/ClassicAndarBahar.jpg",
        alt: "",
        name: "Classic Andar Bahar",
        providerName: "Supernowa",
      },
      GoasAndarBaharSupernowa: {
        redirectUrl: "/casino/sn-goas-andar-bahar",
        code: "DT7M",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/GoasAndarBahar.jpg",
        alt: "",
        name: "Goa's Andar Bahar",
        providerName: "Supernowa",
      },

      Lucky7Supernowa: {
        redirectUrl: "/casino/sn-lucky-7",
        code: "CR",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Lucky7.jpg",
        alt: "",
        name: "Lucky7",
        providerName: "Supernowa",
      },

      RNG3PlayerTeenPattiSupernowa: {
        redirectUrl: "/casino/sn-rng-3-player-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG3PlayerTeenPatti.jpg",
        alt: "",
        name: "RNG 3 Player Teen Patti",
        providerName: "Supernowa",
      },
      RNG32CardsSupernowa: {
        redirectUrl: "/casino/sn-rng-32-cards",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG32Cards.jpg",
        alt: "",
        name: "RNG 32 Cards",
        providerName: "Supernowa",
      },
      RNGAkbarRomeoWalterSupernowa: {
        redirectUrl: "/casino/sn-rng-akbar-romeo-walter",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGAkbarRomeoWalter.jpg",
        alt: "",
        name: "RNG Akbar Romeo Walter",
        providerName: "Supernowa",
      },

      RNGBaccaratSupernowa: {
        redirectUrl: "/casino/sn-rng-baccarat",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGBaccarat.jpg",
        alt: "",
        name: "RNG Baccarat",
        providerName: "Supernowa",
      },

      RNGCasinoQueenSupernowa: {
        redirectUrl: "/casino/sn-rng-casino-queen",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen.jpg",
        alt: "",
        name: "RNG Casino Queen",
        providerName: "Supernowa",
      },
      RNGCasinoQueen2020Supernowa: {
        redirectUrl: "/casino/sn-rng-casino-queen-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen2020.jpg",
        alt: "",
        name: "RNG Casino Queen 2020",
        providerName: "Supernowa",
      },

      RNGDragonTigerSupernowa: {
        redirectUrl: "/casino/sn-rng-dragon-tiger",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGDragonTiger.jpg",
        alt: "",
        name: "RNG Dragon Tiger",
        providerName: "Supernowa",
      },
      RNGDragonTiger2020Supernowa: {
        redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGDragonTiger2020.jpg",
        alt: "",
        name: "RNG Dragon Tiger 2020",
        providerName: "Supernowa",
      },

      RNGKingRaceSupernowa: {
        redirectUrl: "/casino/sn-rng-king-race",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGKingRace.jpg",
        alt: "",
        name: "RNG King Race",
        providerName: "Supernowa",
      },
      RNGLucky7Supernowa: {
        redirectUrl: "/casino/sn-rng-lucky-7",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGLucky7.jpg",
        alt: "",
        name: "RNG Lucky 7",
        providerName: "Supernowa",
      },
      RNGPokerSupernowa: {
        redirectUrl: "/casino/sn-rng-poker",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGPoker.jpg",
        alt: "",
        name: "RNG Poker",
        providerName: "Supernowa",
      },

      RNGTeenPattiSupernowa: {
        redirectUrl: "/casino/sn-rng-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGTeenPatti.jpg",
        alt: "",
        name: "RNG Teen Patti",
        providerName: "Supernowa",
      },
      RNGTeenPatti2020Supernowa: {
        redirectUrl: "/casino/sn-rng-teen-patti-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGTeenPatti2020.jpg",
        alt: "",
        name: "RNG Teen Patti 2020",
        providerName: "Supernowa",
      },
      RNGWorliMatkaSupernowa: {
        redirectUrl: "/casino/sn-rng-worli-matka",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGWorliMatka.jpg",
        alt: "",
        name: "RNG Worli Matka",
        providerName: "Supernowa",
      },

      TeenPattiSupernowa: {
        redirectUrl: "/casino/sn-teen-patti",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti.jpg",
        alt: "",
        name: "Teen Patti",
        providerName: "Supernowa",
      },
      TeenPatti2020Supernowa: {
        redirectUrl: "/casino/sn-teen-patti-2020",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti2020.jpg",
        alt: "",
        name: "Teen Patti 2020",
        providerName: "Supernowa",
      },
      TeenPattiFaceOffSupernowa: {
        redirectUrl: "/casino/sn-teen-patti-face-off",
        code: "PK",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPattiFaceOff.jpg",
        alt: "",
        name: "Teen Patti Face Off",
        providerName: "Supernowa",
      },
    },

    name: "Supernowa",
    key: "Supernowa",
  },
  Vivo: {
    slide1: {
      AndarBaharVivo: {
        redirectUrl: "/casino/vivo-andar-bahar",
        imgUrl: "./images/vivo/AndarBahar.jpg",
        name: "Andar Bahar",
        providerName: "Vivo",
      },
      MacauBaccaratVivo: {
        redirectUrl: "/casino/vivo-macau-baccarat",
        imgUrl: "./images/vivo/baccarat/MacauBaccarat.jpg",
        name: "Macau Baccarat",
        providerName: "Vivo",
      },
      EuropeanAutoRoulette: {
        redirectUrl: "/casino/vivo-european-auto-roulette",
        imgUrl: "./images/vivo/roulette/EuropeanAutoRoulette.jpg",
        name: "European Auto Roulette",
        providerName: "Vivo",
      },
      LasVegasBlackjack: {
        redirectUrl: "/casino/vivo-las-vegas-blackjack",
        imgUrl: "./images/vivo/blackjack/LasVegasBlackjack.jpg",
        name: "Las Vegas Blackjack",
        providerName: "Vivo",
      },
      LimitlessBlackjack: {
        redirectUrl: "/casino/vivo-limitless-blackjack",
        imgUrl: "./images/vivo/blackjack/LimitlessBlackjack.jpg",
        name: "Limitless Blackjack",
        providerName: "Vivo",
      },
      oracle360rouletteVivo: {
        redirectUrl: "/casino/vivo-oracle-360-roulette",
        imgUrl: "./images/vivo/roulette/oracle360roulette.jpg",
        name: "Oracle 360 Roulette",
        providerName: "Vivo",
      },
      LasVegasRoulette: {
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        imgUrl: "./images/vivo/roulette/LasVegasRoulette.jpg",
        name: "Las Vegas Roulette",
        providerName: "Vivo",
      },
      PortomasoRoulette: {
        redirectUrl: "/casino/vivo-portomaso-roulette",
        imgUrl: "./images/vivo/roulette/PortomasoRoulette.jpg",
        name: "Portomaso Roulette",
        providerName: "Vivo",
      },
      OrientalRoulette: {
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        imgUrl: "./images/vivo/roulette/OrientalRoulette.jpg",
        name: "Oriental Roulette",
        providerName: "Vivo",
      },
      VABacarat2: {
        redirectUrl: "/casino/vivo-va-bacarat-2",
        imgUrl: "./images/vivo/baccarat/VABacarat2.jpg",
        name: "VA Bacarat 2",
        providerName: "Vivo",
      },
      VABacarat3: {
        redirectUrl: "/casino/vivo-va-bacarat-3",
        imgUrl: "./images/vivo/baccarat/VABacarat3.jpg",
        name: "VA Bacarat 3",
        providerName: "Vivo",
      },
      VABacarat4: {
        redirectUrl: "/casino/vivo-va-bacarat-4",
        imgUrl: "./images/vivo/baccarat/VABacarat4.jpg",
        name: "VA Bacarat 4",
        providerName: "Vivo",
      },
      VABacarat5: {
        redirectUrl: "/casino/vivo-va-bacarat-5",
        imgUrl: "./images/vivo/baccarat/VABacarat5.jpg",
        name: "VA Bacarat 5",
        providerName: "Vivo",
      },
      DragonTigerVivo: {
        redirectUrl: "/casino/vivo-dragon-tiger",
        imgUrl: "./images/vivo/dragontiger/DragonTiger.jpg",
        name: "Dragon Tiger",
        providerName: "Vivo",
      },
      BlackjackVivo: {
        redirectUrl: "/casino/vivo-blackjack",
        imgUrl: "./images/vivo/blackjack/Blackjack.jpg",
        name: "Blackjack",
        providerName: "Vivo",
      },
      GalaxyBaccarat1Vivo: {
        redirectUrl: "/casino/vivo-galaxy-baccarat-1",
        imgUrl: "./images/vivo/baccarat/GalaxyBaccarat1.jpg",
        name: "Galaxy Baccarat 1",
        providerName: "Vivo",
      },
      OracleBlazeRouletteVivo: {
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        imgUrl: "./images/vivo/roulette/OracleBlazeRoulette.jpg",
        name: "Oracle Blaze Roulette",
        providerName: "Vivo",
      },
      GalaxyBaccarat2Vivo: {
        redirectUrl: "/casino/vivo-galaxy-baccarat-2",
        imgUrl: "./images/vivo/baccarat/GalaxyBaccarat2.jpg",
        name: "Galaxy Baccarat 2",
        providerName: "Vivo",
      },
      GalaxyBaccarat3Vivo: {
        redirectUrl: "/casino/vivo-galaxy-baccarat-3",
        imgUrl: "./images/vivo/baccarat/GalaxyBaccarat3.jpg",
        name: "Galaxy Baccarat 3",
        providerName: "Vivo",
      },
      CasinoHolemVivo: {
        redirectUrl: "/casino/vivo-casino-holdem",
        imgUrl: "./images/vivo/poker/CasinoHoldem.jpg",
        name: "Casino Hold'em",
        providerName: "Vivo",
      },
      VARouletteVivo: {
        redirectUrl: "/casino/vivo-va-roulette",
        imgUrl: "./images/vivo/roulette/VARoulette.jpg",
        name: "VA Roulette",
        providerName: "Vivo",
      },
    },

    name: "Vivo",
    key: "Vivo",
  },
  // prgmaticplaytab: {
  //   slide1: {
  //     CoffeeWild: {
  //       redirectUrl: "/casino/pp-coffee-wild",
  //       imgUrl: "./images/slots/pragmaticplay/CoffeeWild.jpg",
  //       name: "Coffee Wild",
  //       providerName: "Pragmatic Play",
  //     },
  //     DownTheRails: {
  //       redirectUrl: "/casino/pp-down-the-rails",
  //       code: "422",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DownTheRails.jpg",
  //       name: "Down The Rails",
  //       providerName: "Pragmatic Play",
  //     },
  //     FLoatingDragonMegaways: {
  //       redirectUrl: "/casino/pp-floating-dragon-megaways",
  //       code: "401",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FLoatingDragonMegaways.jpg",
  //       name: "FLoating Dragon Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     GreedyWOlf: {
  //       redirectUrl: "/casino/pp-greedy-wolf",
  //       code: "411",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GreedyWOlf.jpg",
  //       name: "Greedy WOlf",
  //       providerName: "Pragmatic Play",
  //     },
  //     MagicMoneyMaze: {
  //       redirectUrl: "/casino/pp-magic-money-maze",
  //       code: "404",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MagicMoneyMaze.jpg",
  //       name: "Magic Money Maze",
  //       providerName: "Pragmatic Play",
  //     },
  //     bigbasssplash: {
  //       redirectUrl: "/casino/pp-big-bass-splash",
  //       code: "438",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_bigbasssplash.jpg",
  //       name: "Big Bass Splash",
  //       providerName: "Pragmatic Play",
  //     },
  //     bombbonanza: {
  //       redirectUrl: "/casino/pp-bomb-bonanza",
  //       code: "405",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_bombbonanza.jpg",
  //       name: "Bomb Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     cheekyemperor: {
  //       redirectUrl: "/casino/pp-cheeky-emperor",
  //       code: "414",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_cheekyemperor.jpg",
  //       name: "Cheeky Emperor",
  //       providerName: "Pragmatic Play",
  //     },
  //     cleocatra: {
  //       redirectUrl: "/casino/pp-cleocatra",
  //       code: "434",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_cleocatra.jpg",
  //       name: "Cleocatra",
  //       providerName: "Pragmatic Play",
  //     },
  //     cosmiccash: {
  //       redirectUrl: "/casino/pp-cosmic-cash",
  //       code: "435",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_cosmiccash.jpg",
  //       name: "Cosmic Cash",
  //       providerName: "Pragmatic Play",
  //     },
  //     mahjongpanda: {
  //       redirectUrl: "/casino/pp-mahjong-panda",
  //       code: "427",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_mahjongpanda.jpg",
  //       name: "Mahjong Panda",
  //       providerName: "Pragmatic Play",
  //     },
  //     firehot5: {
  //       redirectUrl: "/casino/pp-fire-hot-5",
  //       code: "436",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_firehot5.jpg",
  //       name: "Fire Hot 5",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide2: {
  //     octobeerfortunes: {
  //       redirectUrl: "/casino/pp-octobeer-fortunes",
  //       code: "403",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_octobeerfortunes.jpg",
  //       name: "Octobeer Fortunes",
  //       providerName: "Pragmatic Play",
  //     },
  //     firehot20: {
  //       redirectUrl: "/casino/pp-fire-hot-20",
  //       code: "426",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_firehot20.jpg",
  //       name: "Fire Hot 20",
  //       providerName: "Pragmatic Play",
  //     },
  //     Qweenofgod: {
  //       redirectUrl: "/casino/pp-queen-of-gods",
  //       code: "433",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_Qweenofgod.jpg",
  //       name: "Queen of Gods",
  //       providerName: "Pragmatic Play",
  //     },
  //     firehot40: {
  //       redirectUrl: "/casino/pp-fire-hot-40",
  //       code: "425",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_firehot40.jpg",
  //       name: "Fire Hot 40",
  //       providerName: "Pragmatic Play",
  //     },
  //     sugarrush: {
  //       redirectUrl: "/casino/pp-sugar-rush",
  //       code: "415",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_sugar_rush.jpg",
  //       name: "Sugar Rush",
  //       providerName: "Pragmatic Play",
  //     },
  //     firehot100: {
  //       redirectUrl: "/casino/pp-fire-hot-100",
  //       code: "413",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_firehot100.jpg",
  //       name: "Fire Hot 100",
  //       providerName: "Pragmatic Play",
  //     },
  //     thegreatstickup: {
  //       redirectUrl: "/casino/pp-the-great-stick-up",
  //       code: "225",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_thegreatstick-up.jpg",
  //       name: "The Great Stick-Up",
  //       providerName: "Pragmatic Play",
  //     },
  //     gorillamayhem: {
  //       redirectUrl: "/casino/pp-gorilla-mayhem",
  //       code: "402",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_gorillamayhem.jpg",
  //       name: "Gorilla Mayhem",
  //       providerName: "Pragmatic Play",
  //     },
  //     ZombieCarnival: {
  //       redirectUrl: "/casino/pp-zombie-carnival",
  //       code: "102",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_ZombieCarnival.jpg",
  //       name: "Zombie Carnival",
  //       providerName: "Pragmatic Play",
  //     },
  //     hottoburnextreme: {
  //       redirectUrl: "/casino/pp-hot-to-burn-extreme",
  //       code: "412",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_hottoburnextreme.jpg",
  //       name: "Hot to Burn Extreme",
  //       providerName: "Pragmatic Play",
  //     },
  //     ShiningHot5: {
  //       redirectUrl: "/casino/pp-shining-hot-5",
  //       code: "421",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ShiningHot5.jpg",
  //       name: "Shining Hot 5",
  //       providerName: "Pragmatic Play",
  //     },
  //     KoiPond: {
  //       redirectUrl: "/casino/pp-koi-pond",
  //       code: "107",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_KoiPond.jpg",
  //       name: "Koi Pond",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide3: {
  //     ShiningHot20: {
  //       redirectUrl: "/casino/pp-shining-hot-20",
  //       code: "424",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ShiningHot20.jpg",
  //       name: "Shining Hot 20",
  //       providerName: "Pragmatic Play",
  //     },
  //     littlegem: {
  //       redirectUrl: "/casino/pp-little-gem-hold-and-spin",
  //       code: "439",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/pgp_littlegem.jpg",
  //       name: "Little Gem Hold & Spin",
  //       providerName: "Pragmatic Play",
  //     },
  //     ShiningHot40: {
  //       redirectUrl: "/casino/pp-shining-hot-40",
  //       code: "428",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ShiningHot40.jpg",
  //       name: "Shining Hot 40",
  //       providerName: "Pragmatic Play",
  //     },
  //     ShiningHot100: {
  //       redirectUrl: "/casino/pp-shining-hot-100",
  //       code: "430",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ShiningHot100.jpg",
  //       name: "Shining Hot 100",
  //       providerName: "Pragmatic Play",
  //     },
  //     tropicaltiki: {
  //       redirectUrl: "/casino/pp-tropical-tiki",
  //       code: "431",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/tropicaltiki.jpg",
  //       name: "Tropical Tiki",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildmanSuperBOnanza: {
  //       redirectUrl: "/casino/pp-wildman-super-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildmanSuperBOnanza.jpg",
  //       name: "Wildman Super Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     LionsGold5: {
  //       redirectUrl: "/casino/pp-5-lions-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/5LionsGold.jpg",
  //       name: "5 Lions Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     piggies7: {
  //       redirectUrl: "/casino/pp-7-piggies",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/7piggies.jpg",
  //       name: "7 piggies",
  //       providerName: "Pragmatic Play",
  //     },
  //     dragon888: {
  //       redirectUrl: "/casino/pp-888-dragons",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/888dragon.jpg",
  //       name: "888 dragon",
  //       providerName: "Pragmatic Play",
  //     },
  //     aladinandthesrcerer: {
  //       redirectUrl: "/casino/pp-aladdin-and-the-sorcerer",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/aladinandthesrcerer.jpg",
  //       name: "Aladin and the sorcerer",
  //       providerName: "Pragmatic Play",
  //     },
  //     ancientegypt: {
  //       redirectUrl: "/casino/pp-ancient-egypt",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ancientegypt.jpg",
  //       name: "Ancient egypt",
  //       providerName: "Pragmatic Play",
  //     },
  //     AncientEgyptClassic: {
  //       redirectUrl: "/casino/pp-ancient-egypt-classic",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/AncientEgyptClassic.jpg",
  //       name: "Ancient Egypt Classic",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide4: {
  //     Asgard: {
  //       redirectUrl: "/casino/pp-asgard",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Asgard.jpg",
  //       name: "Asgard",
  //       providerName: "Pragmatic Play",
  //     },
  //     AztecGems: {
  //       redirectUrl: "/casino/pp-aztec-gems",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/AztecGems.jpg",
  //       name: "Aztec Gems",
  //       providerName: "Pragmatic Play",
  //     },
  //     BuffaloKing: {
  //       redirectUrl: "/casino/pp-buffalo-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BuffaloKing.jpg",
  //       name: "Buffalo King",
  //       providerName: "Pragmatic Play",
  //     },
  //     CaishensCash: {
  //       redirectUrl: "/casino/pp-caishens-cash",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Caishen'sCash.jpg",
  //       name: "Caishen'sCash",
  //       providerName: "Pragmatic Play",
  //     },
  //     ChilliHeat: {
  //       redirectUrl: "/casino/pp-chilli-heat",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ChilliHeat.jpg",
  //       name: "Chilli Heat",
  //       providerName: "Pragmatic Play",
  //     },
  //     DaVincisTreasure: {
  //       redirectUrl: "/casino/pp-da-vincis-treasure",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DaVinci'sTreasure.jpg",
  //       name: "DaVinci's Treasure",
  //       providerName: "Pragmatic Play",
  //     },
  //     diamondsareforever3line: {
  //       redirectUrl: "/casino/pp-diamonds-are-forever-3-lines",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/diamondsareforever3line.jpg",
  //       name: "Diamonds are forever 3 line",
  //       providerName: "Pragmatic Play",
  //     },
  //     EgyptianFortunes: {
  //       redirectUrl: "/casino/pp-egyptian-fortunes",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EgyptianFortunes.jpg",
  //       name: "Egyptian Fortunes",
  //       providerName: "Pragmatic Play",
  //     },
  //     ExtraJuicy: {
  //       redirectUrl: "/casino/pp-extra-juicy",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ExtraJuicy.jpg",
  //       name: "Extra Juicy ",
  //       providerName: "Pragmatic Play",
  //     },
  //     FairytaleFortune: {
  //       redirectUrl: "/casino/pp-fairytale-fortune",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FairytaleFortune.jpg",
  //       name: "Fairytale Fortune ",
  //       providerName: "Pragmatic Play",
  //     },
  //     Fire88: {
  //       redirectUrl: "/casino/pp-fire-88",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Fire88.jpg",
  //       name: "Fire 88",
  //       providerName: "Pragmatic Play",
  //     },
  //     FireStrike: {
  //       redirectUrl: "/casino/pp-fire-strike",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FireStrike.jpg",
  //       name: "Fire Strike",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide5: {
  //     GoldenPig: {
  //       redirectUrl: "/casino/pp-golden-pig",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldenPig.jpg",
  //       name: "Golden Pig",
  //       providerName: "Pragmatic Play",
  //     },
  //     GoldRush: {
  //       redirectUrl: "/casino/pp-gold-rush",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldRush.jpg",
  //       name: "Gold Rush",
  //       providerName: "Pragmatic Play",
  //     },
  //     Greekgods: {
  //       redirectUrl: "/casino/pp-greek-gods",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Greekgods.jpg",
  //       name: "Greek gods",
  //       providerName: "Pragmatic Play",
  //     },
  //     HerculesandPegasus: {
  //       redirectUrl: "/casino/pp-hercules-and-pegasus",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HerculesandPegasus.jpg",
  //       name: "Hercules and Pegasus",
  //       providerName: "Pragmatic Play",
  //     },
  //     HoneyHoneyHoney: {
  //       redirectUrl: "/casino/pp-honey-honey-honey",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HoneyHoneyHoney.jpg",
  //       name: "Honey Honey Honey",
  //       providerName: "Pragmatic Play",
  //     },
  //     HotChilli: {
  //       redirectUrl: "/casino/pp-hot-chilli",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HotChilli.jpg",
  //       name: "Hot Chilli",
  //       providerName: "Pragmatic Play",
  //     },
  //     JadeButterfly: {
  //       redirectUrl: "/casino/pp-jade-butterfly",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JadeButterfly.jpg",
  //       name: "Jade Butterfly",
  //       providerName: "Pragmatic Play",
  //     },
  //     JohnHunterandtheAztecTreasure: {
  //       redirectUrl: "/casino/pp-john-hunter-and-the-aztec-treasure",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl:
  //         "./images/slots/pragmaticplay/JohnHunterandtheAztecTreasure.jpg",
  //       name: "John Hunter and the Aztec Treasure",
  //       providerName: "Pragmatic Play",
  //     },
  //     JohnHunterandtheTomboftheScarabQueen: {
  //       redirectUrl: "/casino/pp-john-hunter-and-the-tomb-of-the-scarab-queen",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl:
  //         "./images/slots/pragmaticplay/JohnHunterandtheTomboftheScarabQueen.jpg",
  //       name: "John Hunter and the Tomb of the ScarabQueen",
  //       providerName: "Pragmatic Play",
  //     },
  //     JokersJewels: {
  //       redirectUrl: "/casino/pp-jokers-jewels",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JokersJewels.jpg",
  //       name: "Jokers Jewels",
  //       providerName: "Pragmatic Play",
  //     },
  //     leprechaun: {
  //       redirectUrl: "/casino/pp-leprechaun-carol",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/leprechaun.jpg",
  //       name: "Leprechaun",
  //       providerName: "Pragmatic Play",
  //     },
  //     LeprechaunSong: {
  //       redirectUrl: "/casino/pp-leprechaun-song",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LeprechaunSong.jpg",
  //       name: "Leprechaun Song",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide6: {
  //     LuckyNewYear: {
  //       redirectUrl: "/casino/pp-lucky-new-year",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyNewYear.jpg",
  //       name: "Lucky New Year",
  //       providerName: "Pragmatic Play",
  //     },
  //     MadameDestiny: {
  //       redirectUrl: "/casino/pp-madame-destiny",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MadameDestiny.jpg",
  //       name: "Madame Destiny",
  //       providerName: "Pragmatic Play",
  //     },
  //     MagicJourney: {
  //       redirectUrl: "/casino/pp-magic-journey",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MagicJourney.jpg",
  //       name: "Magic Journey",
  //       providerName: "Pragmatic Play",
  //     },
  //     Monkeymadness: {
  //       redirectUrl: "/casino/pp-monkey-madness",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Monkeymadness.jpg",
  //       name: "Monkey madness",
  //       providerName: "Pragmatic Play",
  //     },
  //     MonkeyWarrior: {
  //       redirectUrl: "/casino/pp-monkey-warrior",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MonkeyWarrior.jpg",
  //       name: "Monkey Warrior",
  //       providerName: "Pragmatic Play",
  //     },
  //     Mustanggold: {
  //       redirectUrl: "/casino/pp-mustang-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Mustanggold.jpg",
  //       name: "Mustang gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     PekingLuck: {
  //       redirectUrl: "/casino/pp-peking-luck",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PekingLuck.jpg",
  //       name: "Peking Luck",
  //       providerName: "Pragmatic Play",
  //     },
  //     PirateGold: {
  //       redirectUrl: "/casino/pp-pirate-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PirateGold.jpg",
  //       name: "Pirate Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     ReleasetheKraken: {
  //       redirectUrl: "/casino/pp-release-the-kraken",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ReleasetheKraken.jpg",
  //       name: "Release the Kraken",
  //       providerName: "Pragmatic Play",
  //     },
  //     Safariking: {
  //       redirectUrl: "/casino/pp-safari-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Safariking.jpg",
  //       name: "Safari king",
  //       providerName: "Pragmatic Play",
  //     },
  //     Santa: {
  //       redirectUrl: "/casino/pp-santa",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Santa.jpg",
  //       name: "Santa",
  //       providerName: "Pragmatic Play",
  //     },
  //     Super7: {
  //       redirectUrl: "/casino/pp-super-7s",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Super7.jpg",
  //       name: "Super 7",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide7: {
  //     SuperJoker: {
  //       redirectUrl: "/casino/pp-super-joker",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/SuperJoker.jpg",
  //       name: "Super Joker",
  //       providerName: "Pragmatic Play",
  //     },
  //     SweetBonanza: {
  //       redirectUrl: "/casino/pp-sweet-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/SweetBonanza.jpg",
  //       name: "Sweet Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     Sweetbonanzaxmas: {
  //       redirectUrl: "/casino/pp-sweet-bonanza-xmas",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Sweetbonanzaxmas.jpg",
  //       name: "Sweet bonanza xmas",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheDogHouse: {
  //       redirectUrl: "/casino/pp-the-dog-house",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheDogHouse.jpg",
  //       name: "The Dog House",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheGreatChickenEscape: {
  //       redirectUrl: "/casino/pp-the-great-chicken-escape",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheGreatChickenEscape.jpg",
  //       name: "The Great Chicken Escape",
  //       providerName: "Pragmatic Play",
  //     },
  //     TreasureHorse: {
  //       redirectUrl: "/casino/pp-treasure-horse",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TreasureHorse.jpg",
  //       name: "Treasure Horse",
  //       providerName: "Pragmatic Play",
  //     },
  //     TreeofRiches: {
  //       redirectUrl: "/casino/pp-tree-of-riches",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TreeofRiches.jpg",
  //       name: "Tree of Riches",
  //       providerName: "Pragmatic Play",
  //     },
  //     tripledragons: {
  //       redirectUrl: "/casino/pp-triple-dragons",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/tripledragons.jpg",
  //       name: "Triple dragons",
  //       providerName: "Pragmatic Play",
  //     },
  //     TripleTigers: {
  //       redirectUrl: "/casino/pp-triple-tigers",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TripleTigers.jpg",
  //       name: "Triple Tigers",
  //       providerName: "Pragmatic Play",
  //     },
  //     VampiresVSWolves: {
  //       redirectUrl: "/casino/pp-vampires-vs-wolves",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/VampiresVSWolves.jpg",
  //       name: "Vampires VS Wolves",
  //       providerName: "Pragmatic Play",
  //     },
  //     Vegasnights: {
  //       redirectUrl: "/casino/pp-vegas-nights",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Vegasnights.jpg",
  //       name: "Vegas nights",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildGladiator: {
  //       redirectUrl: "/casino/pp-wild-gladiator",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildGladiator.jpg",
  //       name: "Wild Gladiator",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildPixies: {
  //       redirectUrl: "/casino/pp-wild-pixies",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildPixies.jpg",
  //       name: "Wild Pixies",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide8: {
  //     geniewishemin3: {
  //       redirectUrl: "/casino/pp-3-genie-wishes",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/3geniewishe-min.jpg",
  //       name: "3 Geniewishe",
  //       providerName: "Pragmatic Play",
  //     },
  //     KingdomsBattleofRedCliffsmin3: {
  //       redirectUrl: "/casino/pp-3-kingdoms-battle-of-red-cliffs",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl:
  //         "./images/slots/pragmaticplay/3KingdomsBattleofRedCliffs-min.jpg",
  //       name: "3 Kingdoms BattleofRedCliffs",
  //       providerName: "Pragmatic Play",
  //     },
  //     monkeys7min: {
  //       redirectUrl: "/casino/pp-7-monkeys",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/7monkeys-min.jpg",
  //       name: "7 monkeys",
  //       providerName: "Pragmatic Play",
  //     },
  //     Gold888: {
  //       redirectUrl: "/casino/pp-888-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/888Gold-min.jpg",
  //       name: "Gold 888",
  //       providerName: "Pragmatic Play",
  //     },
  //     Beowulf: {
  //       redirectUrl: "/casino/pp-beowulf",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Beowulf.jpg",
  //       name: "Beowulf",
  //       providerName: "Pragmatic Play",
  //     },
  //     Devils13: {
  //       redirectUrl: "/casino/pp-devils-13",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Devils13.jpg",
  //       name: "Devils 13",
  //       providerName: "Pragmatic Play",
  //     },
  //     DiamondStrike: {
  //       redirectUrl: "/casino/pp-diamond-strike",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DiamondStrike.jpg",
  //       name: "Diamond Strike",
  //       providerName: "Pragmatic Play",
  //     },
  //     DragonKingdom: {
  //       redirectUrl: "/casino/pp-dragon-kingdom",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DragonKingdom.jpg",
  //       name: "Dragon Kingdom",
  //       providerName: "Pragmatic Play",
  //     },
  //     dwarvengolddeluxe: {
  //       redirectUrl: "/casino/pp-dwarven-gold-deluxe",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/dwarvengolddeluxe.jpg",
  //       name: "Dwarven gold deluxe",
  //       providerName: "Pragmatic Play",
  //     },
  //     GoldTrain: {
  //       redirectUrl: "/casino/pp-gold-train",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldTrain.jpg",
  //       name: "Gold Train",
  //       providerName: "Pragmatic Play",
  //     },
  //     Greatreef: {
  //       redirectUrl: "/casino/pp-great-reef",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Greatreef.jpg",
  //       name: "Great reef",
  //       providerName: "Pragmatic Play",
  //     },
  //     HerculesSonOfZeus: {
  //       redirectUrl: "/casino/pp-hercules-son-of-zeus",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HerculesSonOfZeus.jpg",
  //       name: "Hercules Son Of Zeus",
  //       providerName: "Pragmatic Play",
  //     },
  //     Hotsafari: {
  //       redirectUrl: "/casino/pp-hot-safari",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Hotsafari.jpg",
  //       name: "Hot safari",
  //       providerName: "Pragmatic Play",
  //     },
  //     irishcharms: {
  //       redirectUrl: "/casino/pp-irish-charms",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/irishcharms.jpg",
  //       name: "Irish charms",
  //       providerName: "Pragmatic Play",
  //     },
  //     JourneytotheWest: {
  //       redirectUrl: "/casino/pp-journey-to-the-west",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JourneytotheWest.jpg",
  //       name: "Journey to the West",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide9: {
  //     ladygodiva: {
  //       redirectUrl: "/casino/pp-lady-godiva",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ladygodiva.jpg",
  //       name: "Lady godiva",
  //       providerName: "Pragmatic Play",
  //     },
  //     LuckyDragons: {
  //       redirectUrl: "/casino/pp-lucky-dragons",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyDragons.jpg",
  //       name: "Lucky Dragons",
  //       providerName: "Pragmatic Play",
  //     },
  //     MightKong: {
  //       redirectUrl: "/casino/pp-mighty-kong",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MightKong.jpg",
  //       name: "Mighty Kong",
  //       providerName: "Pragmatic Play",
  //     },
  //     MoneyRoll: {
  //       redirectUrl: "/casino/pp-money-roll",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MoneyRoll.jpg",
  //       name: "Money Roll",
  //       providerName: "Pragmatic Play",
  //     },
  //     PandasFortune: {
  //       redirectUrl: "/casino/pp-pandas-fortune",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PandasFortune.jpg",
  //       name: "Pandas Fortune",
  //       providerName: "Pragmatic Play",
  //     },
  //     Aztechking: {
  //       redirectUrl: "/casino/pp-aztec-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Aztechking.jpg",
  //       name: "Aztec king",
  //       providerName: "Pragmatic Play",
  //     },
  //     Barnfestival: {
  //       redirectUrl: "/casino/pp-barn-festival",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Barnfestival.jpg",
  //       name: "Barn festival",
  //       providerName: "Pragmatic Play",
  //     },
  //     bullfiesta: {
  //       redirectUrl: "/casino/pp-bull-fiesta",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/bullfiesta.jpg",
  //       name: "Bull fiesta",
  //       providerName: "Pragmatic Play",
  //     },
  //     Chickenchase: {
  //       redirectUrl: "/casino/pp-chicken-chase",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Chickenchase.jpg",
  //       name: "Chicken chase",
  //       providerName: "Pragmatic Play",
  //     },
  //     colossalcashzone: {
  //       redirectUrl: "/casino/pp-colossal-cash-zone",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/colossalcashzone.jpg",
  //       name: "Colossal cash zone",
  //       providerName: "Pragmatic Play",
  //     },
  //     Discolady: {
  //       redirectUrl: "/casino/pp-disco-lady",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Discolady.jpg",
  //       name: "Discolady",
  //       providerName: "Pragmatic Play",
  //     },
  //     Drillthatgold: {
  //       redirectUrl: "/casino/pp-drill-that-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Drillthatgold.jpg",
  //       name: "Drill that gold",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide10: {
  //     eyeofcleopatra: {
  //       redirectUrl: "/casino/pp-eye-of-cleopatra",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/eyeofcleopatra.jpg",
  //       name: "Eye of cleopatra",
  //       providerName: "Pragmatic Play",
  //     },

  //     Goblinheistpowernudge: {
  //       redirectUrl: "/casino/pp-goblin-heist-powernudge",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Goblinheistpowernudge.jpg",
  //       name: "Goblin heist powernudge",
  //       providerName: "Pragmatic Play",
  //     },
  //     northguardians: {
  //       redirectUrl: "/casino/pp-north-guardians",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/northguardians.jpg",
  //       name: "North guardians",
  //       providerName: "Pragmatic Play",
  //     },
  //     mightyofRa: {
  //       redirectUrl: "/casino/pp-might-of-ra",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/mightyofRa.jpg",
  //       name: "Might of Ra",
  //       providerName: "Pragmatic Play",
  //     },
  //     Rainbowgold: {
  //       redirectUrl: "/casino/pp-rainbow-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Rainbowgold.jpg",
  //       name: "Rainbow gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     snakesandladders: {
  //       redirectUrl: "/casino/pp-snakes-and-ladders-megadice",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/snakesandladders.jpg",
  //       name: "Snakes and ladders",
  //       providerName: "Pragmatic Play",
  //     },
  //     spaceman: {
  //       redirectUrl: "/casino/pp-spaceman",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/spaceman.jpg",
  //       name: "Spaceman",
  //       providerName: "Pragmatic Play",
  //     },
  //     Spiritofadventure: {
  //       redirectUrl: "/casino/pp-spirit-of-adventure",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Spiritofadventure.jpg",
  //       name: "Spirit of adventure",
  //       providerName: "Pragmatic Play",
  //     },
  //     Theultimate5: {
  //       redirectUrl: "/casino/pp-the-ultimate-5",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Theultimate5.jpg",
  //       name: "The ultimate 5",
  //       providerName: "Pragmatic Play",
  //     },
  //     Tictactake: {
  //       redirectUrl: "/casino/pp-tic-tac-take",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Tictactake.jpg",
  //       name: "Tic tac take",
  //       providerName: "Pragmatic Play",
  //     },
  //     wildbeachparty: {
  //       redirectUrl: "/casino/pp-wild-beach-party",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/wildbeachparty.jpg",
  //       name: "wild beach party",
  //       providerName: "Pragmatic Play",
  //     },
  //     wildwestgoldmegaways: {
  //       redirectUrl: "/casino/pp-wild-west-gold-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/wildwestgoldmegaways.jpg",
  //       name: "wild west Goldmegaways",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide11: {
  //     LionsDance5: {
  //       redirectUrl: "/casino/pp-5-lions-dance",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/5LionsDance.jpg",
  //       name: "5 Lions Dances",
  //       providerName: "Pragmatic Play",
  //     },
  //     LionsMegaways5: {
  //       redirectUrl: "/casino/pp-5-lions-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/5LionsMegaways.jpg",
  //       name: "5 Lions Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     AmazingMoneyMachine: {
  //       redirectUrl: "/casino/pp-amazing-money-machine",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/AmazingMoneyMachine.jpg",
  //       name: "Amazing Money Machine",
  //       providerName: "Pragmatic Play",
  //     },
  //     AztecGemsDeluxe: {
  //       redirectUrl: "/casino/pp-aztec-gems-deluxe",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/AztecGemsDeluxe.jpg",
  //       name: "Aztec Gems Deluxe",
  //       providerName: "Pragmatic Play",
  //     },
  //     AztecKingMegaways: {
  //       redirectUrl: "/casino/pp-aztec-king-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/AztecKingMegaways.jpg",
  //       name: "Aztec King Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     BigBassBonanza: {
  //       redirectUrl: "/casino/pp-big-bass-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BigBassBonanza.jpg",
  //       name: "Big Bass Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     BigBassBonanzaMegaways: {
  //       redirectUrl: "/casino/pp-big-bass-bonanza-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BigBassBonanzaMegaways.jpg",
  //       name: "Big Bass Bonanza Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     BigJuan: {
  //       redirectUrl: "/casino/pp-big-juan",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BigJuan.jpg",
  //       name: "Big Juan",
  //       providerName: "Pragmatic Play",
  //     },
  //     BonanzaGold: {
  //       redirectUrl: "/casino/pp-bonanza-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BonanzaGold.jpg",
  //       name: "Bonanza Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     BookofFallen: {
  //       redirectUrl: "/casino/pp-book-of-the-fallen",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BookofFallen.jpg",
  //       name: "Book of Fallen",
  //       providerName: "Pragmatic Play",
  //     },
  //     BookofKingdoms: {
  //       redirectUrl: "/casino/pp-book-of-kingdoms",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BookofKingdoms.jpg",
  //       name: "Book of Kingdoms",
  //       providerName: "Pragmatic Play",
  //     },
  //     BountyGold: {
  //       redirectUrl: "/casino/pp-bounty-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BountyGold.jpg",
  //       name: "Bounty Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide12: {
  //     BroncoSpirit: {
  //       redirectUrl: "/casino/pp-bronco-spirit",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BroncoSpirit.jpg",
  //       name: "Bronco Spirit",
  //       providerName: "Pragmatic Play",
  //     },
  //     BubblePop: {
  //       redirectUrl: "/casino/pp-bubble-pop",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BubblePop.jpg",
  //       name: "Bubble Pop",
  //       providerName: "Pragmatic Play",
  //     },
  //     BuffaloKingMegaways: {
  //       redirectUrl: "/casino/pp-buffalo-king-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/BuffaloKingMegaways.jpg",
  //       name: "Buffalo King Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     CandyVillage: {
  //       redirectUrl: "/casino/pp-candy-village",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CandyVillage.jpg",
  //       name: "Candy Village",
  //       providerName: "Pragmatic Play",
  //     },
  //     CashBonanza: {
  //       redirectUrl: "/casino/pp-cash-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CashBonanza.jpg",
  //       name: "Cash Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     CashElevator: {
  //       redirectUrl: "/casino/pp-cash-elevator",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CashElevator.jpg",
  //       name: "Cash Elevator",
  //       providerName: "Pragmatic Play",
  //     },
  //     ChickenDrop: {
  //       redirectUrl: "/casino/pp-chicken-drop",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ChickenDrop.jpg",
  //       name: "Chicken Drop",
  //       providerName: "Pragmatic Play",
  //     },
  //     ChilliHeatMegaways: {
  //       redirectUrl: "/casino/pp-chilli-heat-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ChilliHeatMegaways.jpg",
  //       name: "Chilli Heat Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     ChristmasBigBassBonanza: {
  //       redirectUrl: "/casino/pp-christmas-big-bass-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ChristmasBigBassBonanza.jpg",
  //       name: "Christmas BigBass Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     ChristmasCarolMegaways: {
  //       redirectUrl: "/casino/pp-christmas-carol-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ChristmasCarolMegaways.jpg",
  //       name: "Christmas Carol Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     CongoCash: {
  //       redirectUrl: "/casino/pp-congo-cash",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CongoCash.jpg",
  //       name: "Congo Cash",
  //       providerName: "Pragmatic Play",
  //     },
  //     CowboysGold: {
  //       redirectUrl: "/casino/pp-cowboys-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CowboysGold.jpg",
  //       name: "Cowboys Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide13: {
  //     CrystalCavernsMegaways: {
  //       redirectUrl: "/casino/pp-crystal-caverns-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CrystalCavernsMegaways.jpg",
  //       name: "Crystal Caverns Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     CurseoftheWerewolfMegaways: {
  //       redirectUrl: "/casino/pp-curse-of-the-werewolf-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/CurseoftheWerewolf-Megaways.jpg",
  //       name: "Curse of the Werewolf-Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     DanceParty: {
  //       redirectUrl: "/casino/pp-dance-party",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DanceParty.jpg",
  //       name: "Dance Party",
  //       providerName: "Pragmatic Play",
  //     },
  //     DayofDead: {
  //       redirectUrl: "/casino/pp-day-of-dead",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DayofDead.jpg",
  //       name: "Day of Dead",
  //       providerName: "Pragmatic Play",
  //     },
  //     DragoJewelsofFortune: {
  //       redirectUrl: "/casino/pp-drago-jewels-of-fortune",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DragoJewelsofFortune.jpg",
  //       name: "Drago Jewels of Fortune",
  //       providerName: "Pragmatic Play",
  //     },
  //     DragonHotHoldandSpin: {
  //       redirectUrl: "/casino/pp-dragon-hot-hold-and-spin",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DragonHotHoldandSpin.jpg",
  //       name: "DragonHot HoldandSpin",
  //       providerName: "Pragmatic Play",
  //     },
  //     DragonKingdomEyesofFire: {
  //       redirectUrl: "/casino/pp-dragon-kingdom-eyes-of-fire",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/DragonKingdomEyesofFire.jpg",
  //       name: "Dragon Kingdom EyesofFire",
  //       providerName: "Pragmatic Play",
  //     },
  //     ElementalGemsMegaways: {
  //       redirectUrl: "/casino/pp-elemental-gems-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ElementalGemsMegaways.jpg",
  //       name: "Elemental Gems Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     EmeraldKing: {
  //       redirectUrl: "/casino/pp-emerald-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EmeraldKing.jpg",
  //       name: "Emerald King",
  //       providerName: "Pragmatic Play",
  //     },
  //     EmeraldKingRainbowRoad: {
  //       redirectUrl: "/casino/pp-emerald-king-rainbow-road",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EmeraldKingRainbowRoad.jpg",
  //       name: "Emerald King RainbowRoad",
  //       providerName: "Pragmatic Play",
  //     },
  //     EmperorCaishen: {
  //       redirectUrl: "/casino/pp-emperor-caishen",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EmperorCaishen.jpg",
  //       name: "Emperor Caishen",
  //       providerName: "Pragmatic Play",
  //     },
  //     EmptytheBank: {
  //       redirectUrl: "/casino/pp-empty-the-bank",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EmptytheBank.jpg",
  //       name: "Empty the Bank",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide14: {
  //     ExtraJuicyMegaways: {
  //       redirectUrl: "/casino/pp-extra-juicy-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ExtraJuicyMegaways.jpg",
  //       name: "Extra Juicy Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     EyeoftheStorm: {
  //       redirectUrl: "/casino/pp-eye-of-the-storm",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/EyeoftheStorm.jpg",
  //       name: "Eye of the Storm",
  //       providerName: "Pragmatic Play",
  //     },
  //     FishinReels: {
  //       redirectUrl: "/casino/pp-fishin-reels",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FishinReels.jpg",
  //       name: "Fishin Reels",
  //       providerName: "Pragmatic Play",
  //     },
  //     FloatingDragon: {
  //       redirectUrl: "/casino/pp-floating-dragon",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FloatingDragon.jpg",
  //       name: "Floating Dragon",
  //       providerName: "Pragmatic Play",
  //     },
  //     FortuneofGiza: {
  //       redirectUrl: "/casino/pp-fortune-of-giza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FortuneofGiza.jpg",
  //       name: "Fortune of Giza",
  //       providerName: "Pragmatic Play",
  //     },
  //     FruitParty: {
  //       redirectUrl: "/casino/pp-fruit-party",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FruitParty.jpg",
  //       name: "Fruit Party",
  //       providerName: "Pragmatic Play",
  //     },
  //     FruitParty2: {
  //       redirectUrl: "/casino/pp-fruit-party-2",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FruitParty2.jpg",
  //       name: "Fruit Party 2",
  //       providerName: "Pragmatic Play",
  //     },
  //     FruitRainbow: {
  //       redirectUrl: "/casino/pp-fruit-rainbow",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FruitRainbow.jpg",
  //       name: "Fruit Rainbow",
  //       providerName: "Pragmatic Play",
  //     },
  //     FuFuFu: {
  //       redirectUrl: "/casino/pp-fu-fu-fu",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/FuFuFu.jpg",
  //       name: "Fu Fu Fu",
  //       providerName: "Pragmatic Play",
  //     },
  //     GatesofOlympus: {
  //       redirectUrl: "/casino/pp-gates-of-olympus",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GatesofOlympus.jpg",
  //       name: "Gates of Olympus",
  //       providerName: "Pragmatic Play",
  //     },
  //     GatesofValhalla: {
  //       redirectUrl: "/casino/pp-gates-of-valhalla",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GatesofValhalla.jpg",
  //       name: "Gates of Valhalla",
  //       providerName: "Pragmatic Play",
  //     },
  //     GemsBonanza: {
  //       redirectUrl: "/casino/pp-gems-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GemsBonanza.jpg",
  //       name: "Gems Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide15: {
  //     GoldenBeauty: {
  //       redirectUrl: "/casino/pp-golden-beauty",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldenBeauty.jpg",
  //       name: "Golden Beauty",
  //       providerName: "Pragmatic Play",
  //     },
  //     GoldenOx: {
  //       redirectUrl: "/casino/pp-golden-ox",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldenOx.jpg",
  //       name: "Golden Ox",
  //       providerName: "Pragmatic Play",
  //     },
  //     GoldParty: {
  //       redirectUrl: "/casino/pp-gold-party",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GoldParty.jpg",
  //       name: "Gold Party",
  //       providerName: "Pragmatic Play",
  //     },
  //     GreatRhinoDeluxe: {
  //       redirectUrl: "/casino/pp-great-rhino-deluxe",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GreatRhinoDeluxe.jpg",
  //       name: "Great Rhino Deluxe",
  //       providerName: "Pragmatic Play",
  //     },
  //     GreatRhinoMegaways: {
  //       redirectUrl: "/casino/pp-great-rhino-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/GreatRhinoMegaways.jpg",
  //       name: "Great Rhino Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     HeartofRio: {
  //       redirectUrl: "/casino/pp-heart-of-rio",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HeartofRio.jpg",
  //       name: "Heart of Rio",
  //       providerName: "Pragmatic Play",
  //     },
  //     HockeyAttack: {
  //       redirectUrl: "/casino/pp-hockey-attack",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HockeyAttack.jpg",
  //       name: "Hockey Attack",
  //       providerName: "Pragmatic Play",
  //     },
  //     HokkaidoWolf: {
  //       redirectUrl: "/casino/pp-hokkaido-wolf",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HokkaidoWolf.jpg",
  //       name: "Hokkaido Wolf",
  //       providerName: "Pragmatic Play",
  //     },
  //     HotFiesta: {
  //       redirectUrl: "/casino/pp-hot-fiesta",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HotFiesta.jpg",
  //       name: "Hot Fiesta",
  //       providerName: "Pragmatic Play",
  //     },
  //     HottoBurn: {
  //       redirectUrl: "/casino/pp-hot-to-burn",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HottoBurn.jpg",
  //       name: "Hot to Burn",
  //       providerName: "Pragmatic Play",
  //     },
  //     HottoBurnHoldandSpin: {
  //       redirectUrl: "/casino/pp-hot-to-burn-hold-and-spin",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/HottoBurnHoldandSpin.jpg",
  //       name: "Hot to Burn HoldandSpin",
  //       providerName: "Pragmatic Play",
  //     },
  //     JohnHunterandtheBookofTut: {
  //       redirectUrl: "/casino/pp-john-hunter-and-the-book-of-tut",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JohnHunterandtheBookofTut.jpg",
  //       name: "John Hunter and the Book of Tut",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide16: {
  //     JohnHunterandtheMayanGods: {
  //       redirectUrl: "/casino/pp-john-hunter-and-the-mayan-gods",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JohnHunterandtheMayanGods.jpg",
  //       name: "John Hunter and the MayanGods",
  //       providerName: "Pragmatic Play",
  //     },
  //     JohnHunterandtheQuestforBermudaRiches: {
  //       redirectUrl: "/casino/pp-john-hunter-and-the-quest-for-bermuda-riches",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl:
  //         "./images/slots/pragmaticplay/JohnHunterandtheQuestforBermudaRiches.jpg",
  //       name: "John Hunter and the Quest for BermudaRiches",
  //       providerName: "Pragmatic Play",
  //     },
  //     JokerKing: {
  //       redirectUrl: "/casino/pp-joker-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JokerKing.jpg",
  //       name: "Joker King",
  //       providerName: "Pragmatic Play",
  //     },
  //     JuicyFruits: {
  //       redirectUrl: "/casino/pp-juicy-fruits",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JuicyFruits.jpg",
  //       name: "Juicy Fruits",
  //       providerName: "Pragmatic Play",
  //     },
  //     JungleGorilla: {
  //       redirectUrl: "/casino/pp-jungle-gorilla",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/JungleGorilla.jpg",
  //       name: "Jungle Gorilla",
  //       providerName: "Pragmatic Play",
  //     },
  //     LuckyDragonBall: {
  //       redirectUrl: "/casino/pp-lucky-dragon-ball",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyDragonBall.jpg",
  //       name: "Lucky DragonBall",
  //       providerName: "Pragmatic Play",
  //     },
  //     LuckyGraceAndCharm: {
  //       redirectUrl: "/casino/pp-lucky-grace-and-charm",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyGraceAndCharm.jpg",
  //       name: "Lucky Grace And Charm",
  //       providerName: "Pragmatic Play",
  //     },
  //     LuckyLightning: {
  //       redirectUrl: "/casino/pp-lucky-lightning",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyLightning.jpg",
  //       name: "Lucky Lightning",
  //       providerName: "Pragmatic Play",
  //     },
  //     LuckyNewYearTigerTreasures: {
  //       redirectUrl: "/casino/pp-lucky-new-year-tiger-treasures",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/LuckyNewYearTigerTreasures.jpg",
  //       name: "Lucky NewYear Tiger Treasures",
  //       providerName: "Pragmatic Play",
  //     },
  //     MadameDestinyMegaways: {
  //       redirectUrl: "/casino/pp-madame-destiny-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MadameDestinyMegaways.jpg",
  //       name: "Madame Destiny Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     MagiciansSecrets: {
  //       redirectUrl: "/casino/pp-magicians-secrets",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Magician'sSecrets.jpg",
  //       name: "Magician's Secrets",
  //       providerName: "Pragmatic Play",
  //     },
  //     MasterJoker: {
  //       redirectUrl: "/casino/pp-master-joker",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MasterJoker.jpg",
  //       name: "Master Joker",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide17: {
  //     MoneyMoneyMoney: {
  //       redirectUrl: "/casino/pp-money-money-money",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MoneyMoneyMoney.jpg",
  //       name: "Money Money Money",
  //       providerName: "Pragmatic Play",
  //     },
  //     Mysterious: {
  //       redirectUrl: "/casino/pp-mysterious",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Mysterious.jpg",
  //       name: "Mysterious",
  //       providerName: "Pragmatic Play",
  //     },
  //     MysteriousEgypt: {
  //       redirectUrl: "/casino/pp-mysterious-egypt",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MysteriousEgypt.jpg",
  //       name: "Mysterious Egypt",
  //       providerName: "Pragmatic Play",
  //     },
  //     MysticChief: {
  //       redirectUrl: "/casino/pp-mystic-chief",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/MysticChief.jpg",
  //       name: "Mystic Chief",
  //       providerName: "Pragmatic Play",
  //     },
  //     PandaFortune2: {
  //       redirectUrl: "/casino/pp-panda-fortune-2",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PandaFortune2.jpg",
  //       name: "Panda Fortune 2",
  //       providerName: "Pragmatic Play",
  //     },
  //     PhoenixForge: {
  //       redirectUrl: "/casino/pp-phoenix-forge",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Phoenix-Forge.jpg",
  //       name: "Phoenix Forge",
  //       providerName: "Pragmatic Play",
  //     },
  //     PiggyBankBills: {
  //       redirectUrl: "/casino/pp-piggy-bank-bills",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PiggyBankBills.jpg",
  //       name: "Piggy Bank Bills",
  //       providerName: "Pragmatic Play",
  //     },
  //     PirateGoldDeluxe: {
  //       redirectUrl: "/casino/pp-pirate-gold-deluxe",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PirateGoldDeluxe.jpg",
  //       name: "Pirate Gold Deluxe",
  //       providerName: "Pragmatic Play",
  //     },
  //     PowerofThorMegaways: {
  //       redirectUrl: "/casino/pp-power-of-thor-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PowerofThorMegaways.jpg",
  //       name: "Power of Thor Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     PyramidBonanza: {
  //       redirectUrl: "/casino/pp-pyramid-bonanza",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PyramidBonanza.jpg",
  //       name: "Pyramid Bonanza",
  //       providerName: "Pragmatic Play",
  //     },
  //     PyramidKing: {
  //       redirectUrl: "/casino/pp-pyramid-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/PyramidKing.jpg",
  //       name: "Pyramid King",
  //       providerName: "Pragmatic Play",
  //     },
  //     RagingBull: {
  //       redirectUrl: "/casino/pp-raging-bull",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/RagingBull.jpg",
  //       name: "Raging Bull",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide18: {
  //     ReturnoftheDead: {
  //       redirectUrl: "/casino/pp-return-of-the-dead",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ReturnoftheDead.jpg",
  //       name: "Return of the Dead",
  //       providerName: "Pragmatic Play",
  //     },
  //     RiseofGizaPowerNudge: {
  //       redirectUrl: "/casino/pp-rise-of-giza-powernudge",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/RiseofGizaPowerNudge.jpg",
  //       name: "Rise of Giza PowerNudge",
  //       providerName: "Pragmatic Play",
  //     },
  //     RiseofSamurai: {
  //       redirectUrl: "/casino/pp-rise-of-samurai",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/RiseofSamurai.jpg",
  //       name: "Rise of Samurai",
  //       providerName: "Pragmatic Play",
  //     },
  //     RiseofSamuraiMegaways: {
  //       redirectUrl: "/casino/pp-rise-of-samurai-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/RiseofSamuraiMegaways.jpg",
  //       name: "Rise of Samurai Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     RockVegas: {
  //       redirectUrl: "/casino/pp-rock-vegas",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/RockVegas.jpg",
  //       name: "Rock Vegas",
  //       providerName: "Pragmatic Play",
  //     },
  //     SantasWonderland: {
  //       redirectUrl: "/casino/pp-santas-wonderland",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/Santa'sWonderland.jpg",
  //       name: "Santa's Wonderland",
  //       providerName: "Pragmatic Play",
  //     },
  //     SmugglersCove: {
  //       redirectUrl: "/casino/pp-smugglers-cove",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/SmugglersCove.jpg",
  //       name: "Smugglers Cove",
  //       providerName: "Pragmatic Play",
  //     },
  //     SpartanKing: {
  //       redirectUrl: "/casino/pp-spartan-king",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/SpartanKing.jpg",
  //       name: "Spartan King",
  //       providerName: "Pragmatic Play",
  //     },
  //     StarBounty: {
  //       redirectUrl: "/casino/pp-star-bounty",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/StarBounty.jpg",
  //       name: "Star Bounty",
  //       providerName: "Pragmatic Play",
  //     },
  //     StarlightPrincess: {
  //       redirectUrl: "/casino/pp-starlight-princess",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/StarlightPrincess.jpg",
  //       name: "Starlight Princess",
  //       providerName: "Pragmatic Play",
  //     },
  //     StarPiratesCode: {
  //       redirectUrl: "/casino/pp-star-pirates-code",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/StarPiratesCode.jpg",
  //       name: "Star Pirates Code",
  //       providerName: "Pragmatic Play",
  //     },
  //     StarzMegaways: {
  //       redirectUrl: "/casino/pp-starz-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/StarzMegaways.jpg",
  //       name: "Starz Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide19: {
  //     StreetRacer: {
  //       redirectUrl: "/casino/pp-street-racer",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/StreetRacer.jpg",
  //       name: "Street Racer",
  //       providerName: "Pragmatic Play",
  //     },
  //     SuperX: {
  //       redirectUrl: "/casino/pp-super-x",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/SuperX.jpg",
  //       name: "Super X",
  //       providerName: "Pragmatic Play",
  //     },
  //     TemujinTreasures: {
  //       redirectUrl: "/casino/pp-temujin-treasures",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TemujinTreasures.jpg",
  //       name: "Temujin Treasures",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheDogHouseMegaways: {
  //       redirectUrl: "/casino/pp-the-dog-house-megaways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheDogHouseMegaways.jpg",
  //       name: "The Dog House Megaways",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheDragonTiger: {
  //       redirectUrl: "/casino/pp-the-dragon-tiger",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheDragonTiger.jpg",
  //       name: "The Dragon Tiger",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheHandofMidas: {
  //       redirectUrl: "/casino/pp-the-hand-of-midas",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheHandofMidas.jpg",
  //       name: "The Hand of Midas",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheMagicCauldron: {
  //       redirectUrl: "/casino/pp-the-magic-cauldron",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheMagicCauldron.jpg",
  //       name: "The Magic Cauldron",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheTigerWarrior: {
  //       redirectUrl: "/casino/pp-the-tiger-warrior",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheTigerWarrior.jpg",
  //       name: "The Tiger Warrior",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheTweetyHouse: {
  //       redirectUrl: "/casino/pp-the-tweety-house",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheTweetyHouse.jpg",
  //       name: "The Tweety House",
  //       providerName: "Pragmatic Play",
  //     },
  //     TheWildMachine: {
  //       redirectUrl: "/casino/pp-the-wild-machine",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TheWildMachine.jpg",
  //       name: "The Wild Machine",
  //       providerName: "Pragmatic Play",
  //     },
  //     ThreeStarFortune: {
  //       redirectUrl: "/casino/pp-three-star-fortune",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/ThreeStarFortune.jpg",
  //       name: "Three Star Fortune",
  //       providerName: "Pragmatic Play",
  //     },
  //     TreasureWild: {
  //       redirectUrl: "/casino/pp-treasure-wild",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/TreasureWild.jpg",
  //       name: "Treasure Wild",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   slide20: {
  //     UltraBurn: {
  //       redirectUrl: "/casino/pp-ultra-burn",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/UltraBurn.jpg",
  //       name: "Ultra Burn",
  //       providerName: "Pragmatic Play",
  //     },
  //     UltraHoldandSpin: {
  //       redirectUrl: "/casino/pp-ultra-hold-and-spin",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/UltraHoldandSpin.jpg",
  //       name: "Ultra Hold and Spin",
  //       providerName: "Pragmatic Play",
  //     },
  //     VoodooMagic: {
  //       redirectUrl: "/casino/pp-voodoo-magic",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/VoodooMagic.jpg",
  //       name: "Voodoo Magic",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildBooster: {
  //       redirectUrl: "/casino/pp-wild-booster",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildBooster.jpg",
  //       name: "Wild Booster",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildDepths: {
  //       redirectUrl: "/casino/pp-wild-depths",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildDepths.jpg",
  //       name: "Wild Depths",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildWalker: {
  //       redirectUrl: "/casino/pp-wild-walker",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildWalker.jpg",
  //       name: "Wild Walker",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildWestGold: {
  //       redirectUrl: "/casino/pp-wild-west-gold",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildWestGold.jpg",
  //       name: "Wild West Gold",
  //       providerName: "Pragmatic Play",
  //     },
  //     WildWildRiches: {
  //       redirectUrl: "/casino/pp-wild-wild-riches",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/WildWildRiches.jpg",
  //       name: "Wild Wild Riches",
  //       providerName: "Pragmatic Play",
  //     },
  //     YumYumPowerways: {
  //       redirectUrl: "/casino/pp-yum-yum-powerways",
  //       code: "104",
  //       casino: "wco",
  //       provider: "PP",
  //       imgUrl: "./images/slots/pragmaticplay/YumYumPowerways.jpg",
  //       name: "Yum Yum Powerways",
  //       providerName: "Pragmatic Play",
  //     },
  //   },
  //   name: "Pragmatic Play",
  // },
  GameShows: {
    slide1: {
      StockMarketEvolution: {
        redirectUrl: "/casino/ezgevo-stock-market",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/stockmarket.jpg",
        alt: "",
        name: "Stock Market",
        providerName: "Evolution",
      },
      CrazyTimeEvolution: {
        redirectUrl: "/casino/ezgevo-crazy-time",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/CrazyTime.jpg",
        alt: "",
        name: "Crazy Time",
        providerName: "Evolution",
      },
      ExtraChilliEpicSpinsEvolution: {
        redirectUrl: "/casino/ezgevo-extra-chilli-epic-spins",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/ExtraChilliEpicSpins.jpg",
        alt: "",
        name: "Extra Chilli Epic Spins",
        providerName: "Evolution",
      },
      DeadorAliveEvolution: {
        redirectUrl: "/casino/ezgevo-dead-or-alive-saloon",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/deadoralive.jpg",
        alt: "",
        name: "Dead or Alive: Saloon",
        providerName: "Evolution",
      },
      // GonzoTreasureHuntEvolution: {
      //   redirectUrl: "/casino/ezgevo-gonzos-treasure-hunt",
      //   code: "1000112",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/gameshows/GonzosTreasureHunt.jpg",
      //   alt: "",
      //   name: "Gonzo's Treasure Hunt",
      //   providerName: "Evolution",
      // },
      CashorCrashEvolution: {
        redirectUrl: "/casino/ezgevo-cash-or-crash",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/CashorCrash.jpg",
        alt: "",
        name: "Cash or Crash",
        providerName: "Evolution",
      },
      DreamCatcherEvolution: {
        redirectUrl: "/casino/ezgevo-dream-catcher",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/DreamCatcher.jpg",
        alt: "",
        name: "Dream Catcher",
        providerName: "Evolution",
      },
      FirstPersonDreamCatcherEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-dream-catcher",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/FirstPersonDreamCatcher.jpg",
        alt: "",
        name: "First Person Dream Catcher",
        providerName: "Evolution",
      },
      FirstPersonMegaballEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-mega-ball",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/FirstPersonMegaball.jpg",
        alt: "",
        name: "First Person Megaball",
        providerName: "Evolution",
      },
      FirstPersonTopCardEvolution: {
        redirectUrl: "/casino/ezgevo-first-person-top-card",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/FirstPersonTopCard.jpg",
        alt: "",
        name: "First Person Top Card",
        providerName: "Evolution",
      },
      MegaballEvolution: {
        redirectUrl: "/casino/ezgevo-mega-ball",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/Megaball.jpg",
        alt: "",
        name: "Megaball",
        providerName: "Evolution",
      },
      FootballStudioEvolution: {
        redirectUrl: "/casino/ezgevo-football-studio",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/gameshows/Footballstudio.jpg",
        alt: "",
        name: "Football studio",
        providerName: "Evolution",
      },
      LightningDiceEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-dice",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/LightningDice.jpg",
        alt: "",
        name: "Lightning Dice",
        providerName: "Evolution",
      },
      MegaballEvolution: {
        redirectUrl: "/casino/ezgevo-mega-ball",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/Megaball.jpg",
        alt: "",
        name: "Megaball",
        providerName: "Evolution",
      },
    },

    name: "Game Shows",
    key: "GameShows",
  },
  PopularGames: {
    slide1: {
      AndarBaharEzugi: {
        redirectUrl: "/casino/ezg-andar-bahar",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/popular/ezugi/AndarBahar.jpg",
        alt: "",
        name: "AndarBahar",
        providerName: "Ezugi",
      },
      AutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-auto-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      BaccaratEzugi: {
        redirectUrl: "/casino/ezg-baccarat",
        code: "1000141",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Ezugi",
      },
      BetonTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-bet-on-teen-patti",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/BetonTeenPatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      CasinoHoldemEzugi: {
        redirectUrl: "/casino/ezg-casino-holdem",
        code: "150",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CasinoHoldem.jpg",
        alt: "",
        name: "Casino Hold'em",
        providerName: "Ezugi",
      },
      CricketAutoRoulette: {
        redirectUrl: "/casino/ezg-cricket-auto-roulette",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/cricketautoroulette.jpg",
        alt: "",
        name: "Cricket Auto Roulette",
        providerName: "Ezugi",
      },
      CricketWar: {
        redirectUrl: "/casino/ezg-cricket-war",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CricketWar.jpg",
        alt: "",
        name: "Cricket War",
        providerName: "Ezugi",
      },
      DiamondRouletteEzugi: {
        redirectUrl: "/casino/ezg-diamond-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      DragonTigerEzugi: {
        redirectUrl: "/casino/ezg-dragon-tiger",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
      Lucky7Ezugi: {
        redirectUrl: "/casino/ezg-lucky-7",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/lucky7.jpg",
        alt: "",
        name: "Lucky 7",
        providerName: "Ezugi",
      },
      NamasteRouletteEzugi: {
        redirectUrl: "/casino/ezg-namaste-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/NamasteRoulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRouletteEzugi: {
        redirectUrl: "/casino/ezg-speed-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/SpeedAutoRoulette.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Ezugi",
      },
     
      TeenPatti3CardEzugi: {
        redirectUrl: "/casino/ezg-teen-patti-3-card",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/TeenPatti3Card.jpg",
        alt: "",
        name: "Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      UltimateAndarBahar: {
        redirectUrl: "/casino/ezg-ultimate-andar-bahar",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateandarbahar.jpg",
        alt: "",
        name: "Ultimate Andar Bahar",
        providerName: "Ezugi",
      },
      UltimateRoulette: {
        redirectUrl: "/casino/ezg-ultimate-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateroulette.jpg",
        alt: "",
        name: "Ultimate Roulette",
        providerName: "Ezugi",
      },
      UltimateSicBo: {
        redirectUrl: "/casino/ezg-ultimate-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/UltimateSicBo.jpg",
        alt: "",
        name: "Ultimate SicBo",
        providerName: "Ezugi",
      },
      Cards32: {
        redirectUrl: "/casino/ezg-32-cards",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/32Cards.jpg",
        alt: "",
        name: "32 Cards",
        providerName: "Ezugi",
      },
    },

    name: "Popular Games",
    key: "PopularGames",
  },
  IndianGames: {
    slide1: {
      AndarBaharEzugi: {
        redirectUrl: "/casino/ezg-andar-bahar",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/ezugi"),
        imgUrl: "./images/popular/ezugi/AndarBahar.jpg",
        alt: "",
        name: "AndarBahar",
        providerName: "Ezugi",
      },
      BetonTeenPattiEzugi: {
        redirectUrl: "/casino/ezugi/ezg-bet-on-teen-patti",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/BetonTeenPatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      CricketWar: {
        redirectUrl: "/casino/ezg-cricket-war",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/CricketWar.jpg",
        alt: "",
        name: "Cricket War",
        providerName: "Ezugi",
      },
      Lucky7Ezugi: {
        redirectUrl: "/casino/ezg-lucky-7",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/lucky7.jpg",
        alt: "",
        name: "Lucky 7",
        providerName: "Ezugi",
      },
      NamasteRouletteEzugi: {
        redirectUrl: "/casino/ezg-namaste-roulette",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/NamasteRoulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      OneDayTeenPattiEzugi: {
        redirectUrl: "/casino/ezg-one-day-teen-patti",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/indiangames/ezugi/OneDayTeenPatti.jpg",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
      OTTAndarBaharEzugi: {
        redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/indiangames/ezugi/OTTAndarBahar.jpg",
        alt: "",
        name: "OTT Andar Bahar",
        providerName: "Ezugi",
      },
      TeenPatti3CardEzugi: {
        redirectUrl: "/casino/ezg-teen-patti-3-card",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/TeenPatti3Card.jpg",
        alt: "",
        name: "Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      UltimateAndarBahar: {
        redirectUrl: "/casino/ezg-ultimate-andar-bahar",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/ultimateandarbahar.jpg",
        alt: "",
        name: "Ultimate Andar Bahar",
        providerName: "Ezugi",
      },
      Cards32: {
        redirectUrl: "/casino/ezg-ultimate-sic-bo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/ezugi/32Cards.jpg",
        alt: "",
        name: "32 Cards",
        providerName: "Ezugi",
      },
    },

    name: "Indian Games",
    key: "IndianGames",
  },
  AllGames: {
    slide1: {
      SpeedRoulette: {
        redirectUrl: "/casino/ezugi/SpeedRoulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      DiamondRoulette: {
        redirectUrl: "/casino/ezugi/DiamondRoulette",
        code: "221003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRoulette: {
        redirectUrl: "/casino/ezugi/NamasteRoulette",
        code: "221005",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Namasteroulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      AutoRoulette: {
        redirectUrl: "/casino/ezugi/AutoRoulette",
        code: "5001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRoulette: {
        redirectUrl: "/casino/ezugi/SpeedAutoRoulette",
        code: "1000103",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Speedautoroulleteevo.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      DoubleBallRoulette: {
        redirectUrl: "/casino/ezugi/DoubleBallRoulette",
        code: "1000084",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Doubleball.jpg",
        alt: "",
        name: "Double Ball Roulette",
        providerName: "Evolution",
      },
      FirstPersonAmericanRoulette1: {
        redirectUrl: "/casino/ezugi/FirstPersonAmericanRoulette1",
        code: "1000312",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/firstpersonamericanrouletterevo.jpg",
        alt: "",
        name: "First Person American Roulette",
        providerName: "Evolution",
      },
      FirstPersonRoulette: {
        redirectUrl: "/casino/ezugi/FirstPersonRoulette",
        code: "1000118",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Firstpersonroulette.jpg",
        alt: "",
        name: "First Person Roulette",
        providerName: "Evolution",
      },
      ImmersiveRoulette: {
        redirectUrl: "/casino/ezugi/ImmersiveRoulette",
        code: "1000122",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Immersive.jpg",
        alt: "",
        name: "Immersive Roulette",
        providerName: "Evolution",
      },
      LightningRoulette: {
        redirectUrl: "/casino/ezugi/LightningRoulette",
        code: "1000092",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Lightiningroulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      TurkceRoulette: {
        redirectUrl: "/casino/ezugi/TurkceRoulette",
        code: "501000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Turkce-Rulet.jpg",
        alt: "",
        name: "Türkçe Rulet",
        providerName: "Ezugi",
      },
      RuletkaRoulette: {
        redirectUrl: "/casino/ezugi/RuletkaRoulette",
        code: "601000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Ruletka-Russia.jpg",
        alt: "",
        name: "Ruletka Russia Roulette",
        providerName: "Ezugi",
      },
    },
    slide2: {
      // SlavyankaRoulette: {
      //   redirectUrl: "/casino/ezugi/SlavyankaRoulette",
      //   code: "421002",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/Slavyanka-Roulette.jpg",
      //   alt: "",
      //   name: "Slavyanka Roulette",
      //   providerName: "Ezugi",
      // },
      PrestigeAutoRoulette: {
        redirectUrl: "/casino/ezugi/PrestigeAutoRoulette",
        code: "221004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Prestige-Auto-Roulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      // PortomasoRoulette2: {
      //   redirectUrl: "/casino/ezugi/PortomasoRoulette2",
      //   code: "611004",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/Portomaso-Real-Casino-Roulette1.jpg",
      //   alt: "",
      //   name: "Portomaso Real Casino Roulette",
      //   providerName: "Ezugi",
      // },
      PortomasoRoulette: {
        redirectUrl: "/casino/ezugi/PortomasoRoulette",
        code: "611000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Portomaso-Real-Casino-Roulette2.jpg",
        alt: "",
        name: "Portomaso Real Casino Roulette 2",
        providerName: "Ezugi",
      },
      OracleRoulette: {
        redirectUrl: "/casino/ezugi/OracleRoulette",
        code: "611003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Oracle-Roulette-360.jpg",
        alt: "",
        name: "Oracle Roulette 360",
        providerName: "Ezugi",
      },
      OracleCasinoRoulette: {
        redirectUrl: "/casino/ezugi/OracleCasinoRoulette",
        code: "611001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Oracle-Casino-Roulette.jpg",
        alt: "",
        name: "Oracle Casino Roulette",
        providerName: "Ezugi",
      },
      // OracleBlazeRoulette: {
      //   redirectUrl: "/casino/ezugi/OracleBlazeRoulette",
      //   code: "611006",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/Oracle-Blaze.jpg",
      //   alt: "",
      //   name: "Oracle Blaze Roulette",
      //   providerName: "Ezugi",
      // },
      CasinoMarinaRoulette2: {
        redirectUrl: "/casino/ezugi/CasinoMarinaRoulette2",
        code: "321001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Casino-Marina-Roulette-2.jpg",
        alt: "",
        name: "Casino Marina Roulette 2",
        providerName: "Ezugi",
      },
      CasinoMarinaRoulette: {
        redirectUrl: "/casino/ezugi/CasinoMarinaRoulette",
        code: "321000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Casino-Marina-Roulette.jpg",
        alt: "",
        name: "Casino Marina Roulette",
        providerName: "Ezugi",
      },
    },
    slide3: {
      Baccarat: {
        redirectUrl: "/casino/ezugi/Baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },
      Nocommissiobaccarat: {
        redirectUrl: "/casino/ezugi/Nocommissiobaccarat",
        code: "1000018",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat02.jpg",
        alt: "",
        name: "No Commission Baccarart",
        providerName: "Evolution",
      },
      Knockoutbaccarat: {
        redirectUrl: "/casino/ezugi/Knockoutbaccarat",
        code: "120",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat03.jpg",
        alt: "",
        name: "Knock Out Baccarart",
        providerName: "Ezugi",
      },
      Super6baccarat: {
        redirectUrl: "/casino/ezugi/Super6baccarat",
        code: "130",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat04.jpg",
        alt: "",
        name: "Super 6 Baccarart",
        providerName: "Ezugi",
      },
      Marinabaccarat: {
        redirectUrl: "/casino/ezugi/Marinabaccarat",
        code: "32100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat05.jpg",
        alt: "",
        name: "Casino Marina Baccarart 1",
        providerName: "Ezugi",
      },

      Marina02baccarat: {
        redirectUrl: "/casino/ezugi/Marina02baccarat",
        code: "32101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat06.jpg",
        alt: "",
        name: "Casino Marina Baccarart 2",
        providerName: "Ezugi",
      },
      NoCommissionBaccarat: {
        redirectUrl: "/casino/ezugi/NoCommissionBaccarat",
        code: "170",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/nocommissionbaccarat.jpg",
        alt: "",
        name: "No Commission Baccarart",
        providerName: "Ezugi",
      },

      SpeedFortuneBaccarat: {
        redirectUrl: "/casino/ezugi/SpeedFortuneBaccarat",
        code: "105",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/speed-fortune-baccarta.jpg",
        alt: "",
        name: " Speed Fortune Baccarart",
        providerName: "Ezugi",
      },
      CricketWarBaccarat: {
        redirectUrl: "/casino/ezugi/CricketWarBaccarat",
        code: "45100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Cricket-War.jpg",
        alt: "",
        name: " Cricket War",
        providerName: "Evolution",
      },
    },
    slide4: {
      SpeedBaccaratR: {
        redirectUrl: "/casino/ezugi/SpeedBaccaratR",
        code: "1000270",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SpeedBaccarat.jpg",
        alt: "",
        name: "Speed Baccarart R",
        providerName: "Evolution",
      },
      SpeedBaccaratA: {
        redirectUrl: "/casino/ezugi/SpeedBaccaratA",
        code: "1000021",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/sPEEDBACCARATA.jpg",
        alt: "",
        name: "Speed Baccarart A",
        providerName: "Evolution",
      },
      SPEEDBACCARATB: {
        redirectUrl: "/casino/ezugi/SPEEDBACCARATB",
        code: "1000022",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SPEEDBACCARATB.jpg",
        alt: "",
        name: "Speed Baccarat B",
        providerName: "Ezugi",
      },
      SpeedBaccarartF: {
        redirectUrl: "/casino/ezugi/SpeedBaccarartF",
        code: "1000026",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SpeedBaccaratF.jpg",
        alt: "",
        name: "Speed Baccarat F",
        providerName: "Evolution",
      },
      SpeedbaccratQ: {
        redirectUrl: "/casino/ezugi/SpeedbaccratQ",
        code: "1000269",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SpeedBaccaratq.jpg",
        alt: "",
        name: "Speed Baccarat Q",
        providerName: "Evolution",
      },

      SpeedBaccaratS: {
        redirectUrl: "/casino/ezugi/SpeedBaccaratS",
        code: "1000271",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SpeedBaccaratsevo.jpg",
        alt: "",
        name: "Speed Baccarat S",
        providerName: "Evolution",
      },
      SpeedCricketBaccarat: {
        redirectUrl: "/casino/ezugi/SpeedCricketBaccarat",
        code: "101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Speedcricketbaccarat.jpg",
        alt: "",
        name: "Speed Cricket Baccarat",
        providerName: "Ezugi",
      },
      SpeedBaccaratL: {
        redirectUrl: "/casino/ezugi/SpeedBaccaratL",
        code: "1000276",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/SpeedbaccaratL.jpg",
        alt: "",
        name: "Speed Baccarat L",
        providerName: "Evolution",
      },
      LightBaccarat: {
        redirectUrl: "/casino/ezugi/LightBaccarat",
        code: "1000149",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/lightning-baccarat.jpg",
        alt: "",
        name: "Lightning Baccarat",
        providerName: "Evolution",
      },
      FirstPersonLightBaccarat: {
        redirectUrl: "/casino/ezugi/FirstPersonLightBaccarat",
        code: "1000145",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Firstpersonlightningbaccarat.jpg",
        alt: "",
        name: "First Person Lightning Baccarat",
        providerName: "Evolution",
      },
    },
    slide5: {
      Blackjack: {
        redirectUrl: "/casino/ezugi/Blackjack",
        code: "201",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack01.jpg",
        alt: "",
        name: "Blackjack",
        providerName: "Ezugi",
      },

      BlackjackPro: {
        redirectUrl: "/casino/ezugi/BlackjackPro",
        code: "224",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/vip-surrender-blackjack.jpg",
        alt: "",
        name: "VIP Surrender Blackjack",
        providerName: "Ezugi",
      },
      VIPBlackjack: {
        redirectUrl: "/casino/ezugi/VIPBlackjack",
        code: "225",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/vip-diamond-blackjack.jpg",
        alt: "",
        name: "VIP Diamond Blackjack",
        providerName: "Ezugi",
      },
      ItalianBlackjack: {
        redirectUrl: "/casino/ezugi/ItalianBlackjack",
        code: "226",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/italian-blackjack.jpg",
        alt: "",
        name: "Italian Blackjack",
        providerName: "Ezugi",
      },
      TurkceBlackjack: {
        redirectUrl: "/casino/ezugi/TurkceBlackjack",
        code: "501",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/turkish-blackjack-3.jpg",
        alt: "",
        name: "Turkce Blackjack",
        providerName: "Ezugi",
      },
      BlackjackVIPA: {
        redirectUrl: "/casino/ezugi/BlackjackVIPA",
        code: "1000048",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-VIP-A.jpg",
        alt: "",
        name: "Blackjack VIP A",
        providerName: "Evolution",
      },
      FreebetBlackjack: {
        redirectUrl: "/casino/ezugi/FreebetBlackjack",
        code: "1000066",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Free-Bet-Blackjack.jpg",
        alt: "",
        name: "Freebet Blackjack",
        providerName: "Evolution",
      },
      InfiniteBlackjackGold: {
        redirectUrl: "/casino/ezugi/InfiniteBlackjackGold",
        code: "1000067",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Infinite-Blackjack.jpg",
        alt: "",
        name: "Infinite Blackjack",
        providerName: "Evolution",
      },
      BlackjackGold4: {
        redirectUrl: "/casino/ezugi/BlackjackGold4",
        code: "4",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-Gold-4.jpg",
        alt: "",
        name: "Blackjack Gold 4",
        providerName: "Ezugi",
      },
      BlackjackPlatinum: {
        redirectUrl: "/casino/ezugi/BlackjackPlatinum",
        code: "5",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-Platinum-1.jpg",
        alt: "",
        name: "Platinum Blackjack  ",
        providerName: "Ezugi",
      },
      BlackjackGold3: {
        redirectUrl: "/casino/ezugi/BlackjackGold3",
        code: "203",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-Gold-3.jpg",
        alt: "",
        name: " Blackjack Gold 3  ",
        providerName: "Ezugi",
      },
      ClassicSpeedBlackjack3: {
        redirectUrl: "/casino/ezugi/ClassicSpeedBlackjack3",
        code: "1000226",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Speed-Blackjack-D.jpg",
        alt: "",
        name: " Classic Speed Blackjack 1",
        providerName: "Evolution",
      },
    },
    slide6: {
      BlackjackSilverD: {
        redirectUrl: "/casino/ezugi/BlackjackSilverD",
        code: "1000044",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-Silver-D.jpg",
        alt: "",
        name: "Blackjack Silver D",
        providerName: "Evolution",
      },
      BlackjackVIPE: {
        redirectUrl: "/casino/ezugi/BlackjackVIPE",
        code: "1000052",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-VIP-E.jpg",
        alt: "",
        name: "Blackjack VIP E",
        providerName: "Evolution",
      },

      ClubBlackjack: {
        redirectUrl: "/casino/ezugi/ClubBlackjack",
        code: "502",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Club-Blackjack.jpg",
        alt: "",
        name: "Club Blackjack",
        providerName: "Ezugi",
      },
      RumbaBlackjack2: {
        redirectUrl: "/casino/ezugi/RumbaBlackjack2",
        code: "412",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Rumba-Blackjack-2.jpg",
        alt: "",
        name: "Rumba Blackjack 2",
        providerName: "Ezugi",
      },
      // RumbaBlackjack4: {
      //   redirectUrl: "/casino/ezugi/RumbaBlackjack4",
      //   code: "414",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/blackjack/Rumba-Blackjack-4.jpg",
      //   alt: "",
      //   name: "Rumba Blackjack 4",
      //   providerName: "Ezugi",
      // },
      SalonPriveBlackjackC: {
        redirectUrl: "/casino/ezugi/SalonPriveBlackjackC",
        code: "1000070",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Salon-Prive-Blackjack-C.jpg",
        alt: "",
        name: "Salon Prive Blackjack C",
        providerName: "Evolution",
      },
      SpeedBlackjackD: {
        redirectUrl: "/casino/ezugi/SpeedBlackjackD",
        code: "1000033",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Speed-Blackjack-D1.jpg",
        alt: "",
        name: "Speed Blackjack D",
        providerName: "Evolution",
      },
      AllStarsBlackjackGold: {
        redirectUrl: "/casino/ezugi/AllStarsBlackjackGold",
        code: "504",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/All-Stars-Blackjack.jpg",
        alt: "",
        name: "All Stars Blackjack",
        providerName: "Ezugi",
      },
      BlackjackVIPL: {
        redirectUrl: "/casino/ezugi/BlackjackVIPL",
        code: "1000056",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-VIP-L.jpg",
        alt: "",
        name: "Blackjack VIP L",
        providerName: "Evolution",
      },

      BlackjackGold3: {
        redirectUrl: "/casino/ezugi/BlackjackGold3",
        code: "203",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack-Gold-3.jpg",
        alt: "",
        name: " Blackjack Gold 3  ",
        providerName: "Ezugi",
      },
      ClassicSpeedBlackjack3: {
        redirectUrl: "/casino/ezugi/ClassicSpeedBlackjack3",
        code: "1000228",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Speed-Blackjack-3.jpg",
        alt: "",
        name: " Classic Speed Blackjack 3  ",
        providerName: "Evolution",
      },
      // Blackjack17Azure: {
      //   redirectUrl: "/casino/ezugi/Blackjack17Azure",
      //   code: "521",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/Blackjack17Azure.jpg",
      //   alt: "",
      //   name: "Casino Marina Roulette",
      //   providerName: "Pragmatic Play",
      // },
    },
    slide7: {
      Hand2CasinoHoldem: {
        redirectUrl: "/casino/ezugi/Hand2CasinoHoldem",
        code: "1000073",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/2handcasinoholem.jpg",
        alt: "",
        name: " 2 Hand Casino Holdem",
        providerName: "Evolution",
      },
      BetonTeenPatti: {
        redirectUrl: "/casino/ezugi/BetonTeenPatti",
        code: "227101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Betonteenpatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      Onedayteenpatti: {
        redirectUrl: "/casino/ezugi/Onedayteenpatti",
        code: "227102",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Onedayteenpatti.jpg",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
      SideBetCity: {
        redirectUrl: "/casino/ezugi/SideBetCity",
        code: "1000115",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Sidebetcity.jpg",
        alt: "",
        name: "Side Bet City",
        providerName: "Evolution",
      },
      TeenPatti3card: {
        redirectUrl: "/casino/ezugi/TeenPatti3card",
        code: "227100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Teenpatti3card.jpg",
        alt: "",
        name: " Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      TexasHoldembonus: {
        redirectUrl: "/casino/ezugi/TexasHoldembonus",
        code: "1000111",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/TexasHoldembonus.jpg",
        alt: "",
        name: "Texas Holdem Bonus",
        providerName: "Evolution",
      },
      Ultimatetexasholdem: {
        redirectUrl: "/casino/ezugi/Ultimatetexasholdem",
        code: "1000151",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/ultimatetaxasholden.jpg",
        alt: "",
        name: "Ultimate Texas Holdem",
        providerName: "Evolution",
      },
      // MegaSicBoLobby: {
      //   redirectUrl: "/casino/ezugi/MegaSicBoLobby",
      //   code: "107",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/MegaSicBoLobby.jpg",
      //   alt: "",
      //   name: "Mega Sic Bo Lobby",
      //   providerName: "Pragmatic Play",
      // },
    },
    slide8: {
      aviator: {
        redirectUrl: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/aviator.jpg",

        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      mines: {
        redirectUrl: "/casino/spribe/mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/spribe/goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/spribe/dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/d.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/spribe/plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/spribe/miniroulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/mini.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/spribe/hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/HILO.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },
    slide9: {
      CrazyTime: {
        redirectUrl: "/casino/ezugi/CrazyTime",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/CrazyTime.jpg",
        alt: "",
        name: "Crazy Time",
        providerName: "Evolution",
      },
      DreamCatcher: {
        redirectUrl: "/casino/ezugi/DreamCatcher",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/DreamCatcher.jpg",
        alt: "",
        name: "Dream Catcher",
        providerName: "Evolution",
      },
      FootballStudio: {
        redirectUrl: "/casino/ezugi/FootballStudio",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/FootballStudio.jpg",
        alt: "",
        name: "Football Studio",
        providerName: "Evolution",
      },

      Megaball: {
        redirectUrl: "/casino/ezugi/Megaball",
        code: "1000141",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/Megaball.jpg",
        alt: "",
        name: "Megaball",
        providerName: "Evolution",
      },
      CashorCrash: {
        redirectUrl: "/casino/ezugi/CashorCrash",
        code: "1000352",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/CashorCrash.jpg",
        alt: "",
        name: "Cash or Crash",
        providerName: "Evolution",
      },
      OTTAndarBahar: {
        redirectUrl: "/casino/ezugi/OTTAndarBahar",
        code: "328000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/OTTAndarBahar.jpg",
        alt: "",
        name: "OTT Andar Bahar",
        providerName: "Ezugi",
      },
      SicBo: {
        redirectUrl: "/casino/ezugi/SicBo",
        code: "224000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/SicBo.jpg",
        alt: "",
        name: "SicBo",
        providerName: "Ezugi",
      },
      UltimateSicBo: {
        redirectUrl: "/casino/ezugi/UltimateSicBo",
        code: "224100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/UltimateSicBo.jpg",
        alt: "",
        name: "Ultimate SicBo",
        providerName: "Ezugi",
      },
    },
    name: "All Games",
  },
  slotsgames: {
    slide1: {
      // twinspin: {
      //   redirectUrl: "/casino/ezugi/twinspin",
      //   code: "1100039",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/twin-and-spin.jpg", alt: "" },
      // },
      // gonzoquest: {
      //   redirectUrl: "/casino/ezugi/gonzoquest",
      //   code: "1100018",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/gonzo-treasure-hunt.jpg", alt: "" },
      // },

      // asgardianstones: {
      //   href: "/casino/ezugi/asgardianstones",
      //   code: "1100096",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/asgardianstones1.jpg", alt: "" },
      // },
      // secrets: {
      //   href: "/casino/ezugi/secrets",
      //   code: "1100106",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/secrets.jpg", alt: "" },
      // },
      // grandwheel: {
      //   href: "/casino/ezugi/grandwheel",
      //   code: "1100150",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/Grand-wheel.jpg", alt: "" },
      // },
      // Strike777: {
      //   href: "/casino/ezugi/Strike777",
      //   code: "1100031",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Nights1000: {
      //   href: "/casino/ezugi/Nights1000",
      //   code: "1100003",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // CashUltimate: {
      //   href: "/casino/ezugi/CashUltimate",
      //   code: "1100070",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // CashVolt: {
      //   href: "/casino/ezugi/CashVolt",
      //   code: "1100071",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DazzleMegaways: {
      //   href: "/casino/ezugi/DazzleMegaways",
      //   code: "1100083",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DivinieFortuneMegaways: {
      //   href: "/casino/ezugi/DivinieFortuneMegaways",
      //   code: "1100089",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Dynamiteriches: {
      //   href: "/casino/ezugi/Dynamiteriches",
      //   code: "1100073",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FortuneHouse: {
      //   href: "/casino/ezugi/FortuneHouse",
      //   code: "1100007",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShopMegaways: {
      //   href: "/casino/ezugi/FruitShopMegaways",
      //   code: "1100094",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenCryptex: {
      //   href: "/casino/ezugi/GoldenCryptex",
      //   code: "1100147",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenTsar: {
      //   href: "/casino/ezugi/GoldenTsar",
      //   code: "1100149",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GorillaKingdom: {
      //   href: "/casino/ezugi/GorillaKingdom",
      //   code: "1100088",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MystryReels: {
      //   href: "/casino/ezugi/MystryReels",
      //   code: "1100061",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RageoftheSea: {
      //   href: "/casino/ezugi/RageoftheSea",
      //   code: "1100116",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelKingMegaways: {
      //   href: "/casino/ezugi/ReelKingMegaways",
      //   code: "1100052",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TurnFortune: {
      //   href: "/casino/ezugi/TurnFortune",
      //   code: "1100041",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TwinSpinMegaways: {
      //   href: "/casino/ezugi/TwinSpinMegaways",
      //   code: "1100039",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WillysChills: {
      //   href: "/casino/ezugi/WillysChills",
      //   code: "1100128",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // VikingsSlots: {
      //   href: "/casino/ezugi/VikingsSlots",
      //   code: "1100124",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },

      // ChineseTreasures: {
      //   href: "/casino/ezugi/ChineseTreasures",
      //   code: "1100006",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuck: {
      //   href: "/casino/ezugi/DragonLuck",
      //   code: "1100001",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonFire: {
      //   href: "/casino/ezugi/DragonFire",
      //   code: "1100008",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuckDeluxe: {
      //   href: "/casino/ezugi/DragonLuckDeluxe",
      //   code: "1100011",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonLuckReel: {
      //   href: "/casino/ezugi/DragonLuckReel",
      //   code: "1100002",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // EpicJourney: {
      //   href: "/casino/ezugi/EpicJourney",
      //   code: "1100012",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GodWealth: {
      //   href: "/casino/ezugi/GodWealth",
      //   code: "1100005",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // LuckyFortune: {
      //   href: "/casino/ezugi/LuckyFortune",
      //   code: "1100010",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MagicGate: {
      //   href: "/casino/ezugi/MagicGate",
      //   code: "1100009",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenTemple: {
      //   href: "/casino/ezugi/GoldenTemple",
      //   code: "1100013",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PhoenixPower: {
      //   href: "/casino/ezugi/PhoenixPower",
      //   code: "1100014",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiratesPlenty: {
      //   href: "/casino/ezugi/PiratesPlenty",
      //   code: "1100015",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GoldenOffer: {
      //   href: "/casino/ezugi/GoldenOffer",
      //   code: "1100016",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RAsLegend: {
      //   href: "/casino/ezugi/RAsLegend",
      //   code: "1100017",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GonzoMegawaya: {
      //   href: "/casino/ezugi/GonzoMegawaya",
      //   code: "1100018                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RainbowJAcket: {
      //   href: "/casino/ezugi/RainbowJAcket",
      //   code: "1100019                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MegaPyramid: {
      //   href: "/casino/ezugi/MegaPyramid",
      //   code: "1100020                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Ozzy_Osbourne: {
      //   href: "/casino/ezugi/Ozzy_Osbourne",
      //   code: "1100024                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jimi_Hendrix: {
      //   href: "/casino/ezugi/Jimi_Hendrix",
      //   code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jimi_Hendrix: {
      //   href: "/casino/ezugi/Jimi_Hendrix",
      //   code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Jumanji: {
      //   href: "/casino/ezugi/Jumanji",
      //   code: "1100027                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MotorheadVideoSlot: {
      //   href: "/casino/ezugi/MotorheadVideoSlot",
      //   code: "1100028                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Starburst: {
      //   href: "/casino/ezugi/Starburst",
      //   code: "1100029                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WarofGod: {
      //   href: "/casino/ezugi/WarofGod",
      //   code: "1100030                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Christmas: {
      //   href: "/casino/ezugi/Christmas",
      //   code: "1100032                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ClusterPays: {
      //   href: "/casino/ezugi/ClusterPays",
      //   code: "1100033                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // AncientsBlessing: {
      //   href: "/casino/ezugi/AncientsBlessing",
      //   code: "1100034                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // AurumCodex: {
      //   href: "/casino/ezugi/AurumCodex",
      //   code: "1100035                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GunsNRoses: {
      //   href: "/casino/ezugi/GunsNRoses",
      //   code: "1100036                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BorisandBoo: {
      //   href: "/casino/ezugi/BorisandBoo",
      //   code: "1100037                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WildWest: {
      //   href: "/casino/ezugi/WildWest",
      //   code: "1100038                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SteamTower: {
      //   href: "/casino/ezugi/SteamTower",
      //   code: "1100043                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ZeusLightning: {
      //   href: "/casino/ezugi/ZeusLightning",
      //   code: "1100044                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // WingsofRa: {
      //   href: "/casino/ezugi/WingsofRa",
      //   code: "1100045                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Trillionaire: {
      //   href: "/casino/ezugi/Trillionaire",
      //   code: "1100047                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TreasureMine: {
      //   href: "/casino/ezugi/TreasureMine",
      //   code: "1100048                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ThorVengeance: {
      //   href: "/casino/ezugi/ThorVengeance",
      //   code: "1100049                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RegalStreak: {
      //   href: "/casino/ezugi/RegalStreak",
      //   code: "1100050                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RegalBeasts: {
      //   href: "/casino/ezugi/RegalBeasts",
      //   code: "1100051                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelKeeper: {
      //   href: "/casino/ezugi/ReelKeeper",
      //   code: "1100053                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RainbowJackpotsPowerLines: {
      //   href: "/casino/ezugi/RainbowJackpotsPowerLines",
      //   code: "1100055                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiggyRichesMegaways: {
      //   href: "/casino/ezugi/PiggyRichesMegaways",
      //   code: "1100059                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JingleBells: {
      //   href: "/casino/ezugi/JingleBells",
      //   code: "1100065                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackinaPot: {
      //   href: "/casino/ezugi/JackinaPot",
      //   code: "1100066                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FiveStar: {
      //   href: "/casino/ezugi/FiveStar",
      //   code: "1100068                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BountyRaid: {
      //   href: "/casino/ezugi/BountyRaid",
      //   code: "1100069                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // MysteryReels2: {
      //   href: "/casino/ezugi/MysteryReels2",
      //   code: "1100061                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DiamondBlitz: {
      //   href: "/casino/ezugi/DiamondBlitz",
      //   code: "1100072                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DragonFireMegaways: {
      //   href: "/casino/ezugi/DragonFireMegaways",
      //   code: "1100074                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Rome: {
      //   href: "/casino/ezugi/Rome",
      //   code: "1100075                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ReelRush: {
      //   href: "/casino/ezugi/ReelRush",
      //   code: "1100076                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BloodSuckers: {
      //   href: "/casino/ezugi/BloodSuckers",
      //   code: "1100077                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Pyramid: {
      //   href: "/casino/ezugi/Pyramid",
      //   code: "1100078                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ButterflyStaxx: {
      //   href: "/casino/ezugi/ButterflyStaxx",
      //   code: "1100079                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // PiggyRiches: {
      //   href: "/casino/ezugi/PiggyRiches",
      //   code: "1100080                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DarkKing: {
      //   href: "/casino/ezugi/DarkKing",
      //   code: "1100081                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JingleSpin: {
      //   href: "/casino/ezugi/JingleSpin",
      //   code: "1100082                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Dazzle: {
      //   href: "/casino/ezugi/Dazzle",
      //   code: "1100083                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackHammer: {
      //   href: "/casino/ezugi/JackHammer",
      //   code: "1100084                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive: {
      //   href: "/casino/ezugi/DeadorAlive",
      //   code: "1100085                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackandtheBeanstalk: {
      //   href: "/casino/ezugi/JackandtheBeanstalk",
      //   code: "1100086                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive2: {
      //   href: "/casino/ezugi/DeadorAlive2",
      //   code: "1100087                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DivineFortuneMegaways: {
      //   href: "/casino/ezugi/DivineFortuneMegaways",
      //   code: "1100089                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GordonRamsayHellsKitchen: {
      //   href: "/casino/ezugi/GordonRamsayHellsKitchen",
      //   code: "1100090                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Elements: {
      //   href: "/casino/ezugi/Elements",
      //   code: "1100091                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // GonzosQuest: {
      //   href: "/casino/ezugi/GonzosQuest",
      //   code: "1100092                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FinnandtheSwirlySpin: {
      //   href: "/casino/ezugi/FinnandtheSwirlySpin",
      //   code: "1100093                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShop: {
      //   href: "/casino/ezugi/FruitShop",
      //   code: "1100095                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // BloodSuckers2: {
      //   href: "/casino/ezugi/BloodSuckers2",
      //   code: "1100097                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ButterflyStaxx2: {
      //   href: "/casino/ezugi/ButterflyStaxx2",
      //   code: "1100098                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DazzleMeMegaways: {
      //   href: "/casino/ezugi/DazzleMeMegaways",
      //   code: "1100099                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DeadorAlive2FeatureBuy: {
      //   href: "/casino/ezugi/DeadorAlive2FeatureBuy",
      //   code: "1100100                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DoubleStacks: {
      //   href: "/casino/ezugi/DoubleStacks",
      //   code: "1100101                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FairytaleLegends: {
      //   href: "/casino/ezugi/FairytaleLegends",
      //   code: "1100102                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Flowers: {
      //   href: "/casino/ezugi/Flowers",
      //   code: "1100103                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitShopChristmasEdition: {
      //   href: "/casino/ezugi/FruitShopChristmasEdition",
      //   code: "1100104                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Hotline: {
      //   href: "/casino/ezugi/Hotline",
      //   code: "1100107                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // Hotline2: {
      //   href: "/casino/ezugi/Hotline2",
      //   code: "1100108                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // TheInvisibleMan: {
      //   href: "/casino/ezugi/TheInvisibleMan",
      //   code: "1100109                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // IrishPotLuck: {
      //   href: "/casino/ezugi/IrishPotLuck",
      //   code: "1100110                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JackHammer2: {
      //   href: "/casino/ezugi/JackHammer2",
      //   code: "1100111                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // FruitSpin: {
      //   href: "/casino/ezugi/FruitSpin",
      //   code: "1100112                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // JungleSpirit: {
      //   href: "/casino/ezugi/JungleSpirit",
      //   code: "1100113                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // KoiPrincess: {
      //   href: "/casino/ezugi/KoiPrincess",
      //   code: "1100114                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // DriveMultiplierMayhem: {
      //   href: "/casino/ezugi/DriveMultiplierMayhem",
      //   code: "1100115                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RageoftheSeas: {
      //   href: "/casino/ezugi/RageoftheSeas",
      //   code: "1100116                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // RichesofMidgard: {
      //   href: "/casino/ezugi/RichesofMidgard",
      //   code: "1100117                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // ScruffyDuck: {
      //   href: "/casino/ezugi/ScruffyDuck",
      //   code: "1100118                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SecretoftheStones: {
      //   href: "/casino/ezugi/SecretoftheStones",
      //   code: "1100119                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      // SecretsofChristmas: {
      //   href: "/casino/ezugi/SecretsofChristmas",
      //   code: "1100120                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: "",
      //   cover: { src: "./images/slots/777_Strike.png", alt: "" },
      // },
      SerengetiKings: {
        redirectUrl: "/casino/ezugi/SerengetiKings",
        code: "1100121                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Serengeti-Kings.jpg",
        alt: "",
        name: "Serengeti Kings",
        providerName: "NetEnt",
      },
      SpaceWars: {
        redirectUrl: "/casino/ezugi/SpaceWars",
        code: "1100122                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Space-Wars.jpg",
        alt: "",
        name: "Space Wars",
        providerName: "NetEnt",
      },
      Victorious: {
        redirectUrl: "/casino/ezugi/Victorious",
        code: "1100123                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Victorious.jpg",
        alt: "",
        name: "Victorious",
        providerName: "NetEnt",
      },
      Warlords: {
        redirectUrl: "/casino/ezugi/Warlords",
        code: "1100125                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Warlords-Crystal-of-Power.jpg",
        alt: "",
        name: "Warlords: Crystal of Power",
        providerName: "NetEnt",
      },
      WildWater: {
        redirectUrl: "/casino/ezugi/WildWater",
        code: "1100126                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Water.jpg",
        alt: "",
        name: "Wild Water",
        providerName: "NetEnt",
      },
      WildWorlds: {
        redirectUrl: "/casino/ezugi/WildWorlds",
        code: "1100127                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Worlds.jpg",
        alt: "",
        name: "Wild Worlds",
        providerName: "NetEnt",
      },
      Squad4: {
        redirectUrl: "/casino/ezugi/Squad4",
        code: "1100129                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/4-Squad.jpg",
        alt: "",
        name: "4 Squad",
        providerName: "Red Tiger",
      },
      Families5: {
        redirectUrl: "/casino/ezugi/Families5",
        code: "1100130                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/5-Families.jpg",
        alt: "",
        name: "5 Families",
        providerName: "Red Tiger",
      },
      AgentRoyale: {
        redirectUrl: "/casino/ezugi/AgentRoyale",
        code: "1100131                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Agent-Royale.jpg",
        alt: "",
        name: "Agent Royale",
        providerName: "Red Tiger",
      },
      ArcadeBomb: {
        redirectUrl: "/casino/ezugi/ArcadeBomb",
        code: "1100132                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Arcade-Bomb.jpg",
        alt: "",
        name: "Arcade Bomb",
        providerName: "Red Tiger",
      },
      Atlantis: {
        redirectUrl: "/casino/ezugi/Atlantis",
        code: "1100133                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Atlantis.jpg",
        alt: "",
        name: "Atlantis",
        providerName: "Red Tiger",
      },
      AztecSpins: {
        redirectUrl: "/casino/ezugi/AztecSpins",
        code: "1100134                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Aztec-Spins.jpg",
        alt: "",
        name: "Aztec Spins",
        providerName: "Red Tiger",
      },
      CinderellaBall: {
        redirectUrl: "/casino/ezugi/CinderellaBall",
        code: "1100135                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Cinderella`s-Ball.jpg",
        alt: "",
        name: "Cinderella`s Ball",
        providerName: "Red Tiger",
      },
      CirquedelaFortune: {
        redirectUrl: "/casino/ezugi/CirquedelaFortune",
        code: "1100136                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Cirque-de-la-Fortune.jpg",
        alt: "",
        name: "Cirque de la Fortune",
        providerName: "Red Tiger",
      },
      ClashoftheBeasts: {
        redirectUrl: "/casino/ezugi/ClashoftheBeasts",
        code: "1100137                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Clash-of-the-Beasts.jpg",
        alt: "",
        name: "Clash of the Beasts",
        providerName: "Red Tiger",
      },
      CrazyGenie: {
        redirectUrl: "/casino/ezugi/CrazyGenie",
        code: "1100138                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Crazy-Genie.jpg",
        alt: "",
        name: "Crazy Genie",
        providerName: "Red Tiger",
      },
      CrystalMirror: {
        redirectUrl: "/casino/ezugi/CrystalMirror",
        code: "1100139                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Crystal-Mirror.jpg",
        alt: "",
        name: "Crystal Mirror",
        providerName: "Red Tiger",
      },
      DaVinciMystery: {
        redirectUrl: "/casino/ezugi/DaVinciMystery",
        code: "1100140                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Da-Vinci`s-Mystery.jpg",
        alt: "",
        name: "Da Vinci`s Mystery",
        providerName: "Red Tiger",
      },
      DevilNumber: {
        redirectUrl: "/casino/ezugi/DevilNumber",
        code: "1100141                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Devil`s-Number.jpg",
        alt: "",
        name: "Devil`s Number",
        providerName: "Red Tiger",
      },
      DiceDice: {
        redirectUrl: "/casino/ezugi/DiceDice",
        code: "1100142                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Dice-Dice-Dice.jpg",
        alt: "",
        name: "Dice Dice Dice",
        providerName: "Red Tiger",
      },
      FiveStarsPowerReels: {
        redirectUrl: "/casino/ezugi/FiveStarsPowerReels",
        code: "1100144                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Five-Stars-Power-Reels.jpg",
        alt: "",
        name: "Five Stars Power Reels",
        providerName: "Red Tiger",
      },
      GemsGoneWild: {
        redirectUrl: "/casino/ezugi/GemsGoneWild",
        code: "1100145                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Gems-Gone-Wild.jpg",
        alt: "",
        name: "Gems Gone Wild",
        providerName: "Red Tiger",
      },
      GemsGoneWildPowerReels: {
        redirectUrl: "/casino/ezugi/GemsGoneWildPowerReels",
        code: "1100146                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Gems-Gone-Wild-Power-Reels.jpg",
        alt: "",

        name: "Gems Gone Wild Power Reels",
        providerName: "Red Tiger",
      },
      GoldenLeprechaunMegaways: {
        redirectUrl: "/casino/ezugi/GoldenLeprechaunMegaways",
        code: "1100148                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Golden-Leprechaun-Megaways.jpg",
        alt: "",

        name: "Golden Leprechaun Megaways",
        providerName: "Red Tiger",
      },
      HoardofPoseidon: {
        redirectUrl: "/casino/ezugi/HoardofPoseidon",
        code: "1100151                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Hoard-of-Poseidon.jpg",
        alt: "",
        name: "Hoard of Poseidon",
        providerName: "Red Tiger",
      },
      JewelScarabs: {
        redirectUrl: "/casino/ezugi/JewelScarabs",
        code: "1100152                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Jewel-Scarabs.jpg",
        alt: "",
        name: "Jewel Scarabs",
        providerName: "Red Tiger",
      },
      JingleBellsPowerReels: {
        redirectUrl: "/casino/ezugi/JingleBellsPowerReels",
        code: "1100153                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Jingle-Bells-Power-Reels.jpg",
        alt: "",
        name: "Jingle Bells Power Reels",
        providerName: "Red Tiger",
      },
      LegendofAthena: {
        redirectUrl: "/casino/ezugi/LegendofAthena",
        code: "1100154                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Legend-of-Athena.jpg",
        alt: "",
        name: "Legend of Athena",
        providerName: "Red Tiger",
      },
      LuckyHalloween: {
        redirectUrl: "/casino/ezugi/LuckyHalloween",
        code: "1100155                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Halloween.jpg",
        alt: "",
        name: "Lucky Halloween",
        providerName: "Red Tiger",
      },
      LuckyLittleDevil: {
        redirectUrl: "/casino/ezugi/LuckyLittleDevil",
        code: "1100156                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Little-Devil.jpg",
        alt: "",
        name: "Lucky Little Devil",
        providerName: "Red Tiger",
      },
      LuckyValentine: {
        redirectUrl: "/casino/ezugi/LuckyValentine",
        code: "1100157                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Valentine.jpg",
        alt: "",
        name: "Lucky Valentine",
        providerName: "Red Tiger",
      },
      LuckyWizard: {
        redirectUrl: "/casino/ezugi/LuckyWizard",
        code: "1100158                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Lucky-Wizard.jpg",
        alt: "",
        name: "Lucky Wizard",
        providerName: "Red Tiger",
      },
      Masquerade: {
        redirectUrl: "/casino/ezugi/Masquerade",
        code: "1100159                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Masquerade.jpg",
        alt: "",
        name: "Masquerade",
        providerName: "Red Tiger",
      },
      MayanGods: {
        redirectUrl: "/casino/ezugi/MayanGods",
        code: "1100160                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mayan-Gods.jpg",
        alt: "",
        name: "Mayan Gods",
        providerName: "Red Tiger",
      },
      MegaDragon: {
        redirectUrl: "/casino/ezugi/MegaDragon",
        code: "1100161                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Dragon.jpg",
        alt: "",
        name: "Mega Dragon",
        providerName: "Red Tiger",
      },
      MegaJade: {
        redirectUrl: "/casino/ezugi/MegaJade",
        code: "1100162                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Jade.jpg",
        alt: "",
        name: "Mega Jade",
        providerName: "Red Tiger",
      },
      MegaRise: {
        redirectUrl: "/casino/ezugi/MegaRise",
        code: "1100163                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mega-Rise.jpg",
        alt: "",
        name: "Mega Rise",
        providerName: "Red Tiger",
      },
      MultiplierRiches: {
        redirectUrl: "/casino/ezugi/MultiplierRiches",
        code: "1100164                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Multiplier-Riches.jpg",
        alt: "",
        name: "Mystery Reels Megaways",
        providerName: "Red Tiger",
      },
      MysteryReelsMegaways: {
        redirectUrl: "/casino/ezugi/MysteryReelsMegaways",
        code: "1100165                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Mystery_Reels_Megaways.jpg",
        alt: "",
        name: "Mystery Reels Megaways",
        providerName: "Red Tiger",
      },
      NinjaWays: {
        redirectUrl: "/casino/ezugi/NinjaWays",
        code: "1100166                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Ninja-Ways.jpg",
        alt: "",
        name: "Ninja Ways",
        providerName: "Red Tiger",
      },
      PathofDestiny: {
        redirectUrl: "/casino/ezugi/PathofDestiny",
        code: "1100167                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Path-of-Destiny.jpg",
        alt: "",
        name: "Path of Destiny",
        providerName: "Red Tiger",
      },
      PersianFortune: {
        redirectUrl: "/casino/ezugi/PersianFortune",
        code: "1100168                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Persian-Fortune.jpg",
        alt: "",
        name: "Persian Fortune",
        providerName: "Red Tiger",
      },
      ReelHeist: {
        redirectUrl: "/casino/ezugi/ReelHeist",
        code: "1100169                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Reel-Heist.jpg",
        alt: "",
        name: "Reel Heist",
        providerName: "Red Tiger",
      },
      RobinHoodWildForest: {
        redirectUrl: "/casino/ezugi/RobinHoodWildForest",
        code: "1100170                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.jpg",
        alt: "",
        name: "Robin Hood`s Wild Forest",
        providerName: "Red Tiger",
      },
      SnowWild: {
        redirectUrl: "/casino/ezugi/SnowWild",
        code: "1100171                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.jpg",
        alt: "",

        name: "Snow Wild And The 7 Features",
        providerName: "Red Tiger",
      },
      SylvanSpirits: {
        redirectUrl: "/casino/ezugi/SylvanSpirits",
        code: "1100172                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Sylvan-Spirits.jpg",
        alt: "",
        name: "Sylvan Spirits",
        providerName: "Red Tiger",
      },
      TheGreatestTrainRobbery: {
        redirectUrl: "/casino/ezugi/TheGreatestTrainRobbery",
        code: "1100173                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/The-Greatest-Train-Robbery.jpg",
        alt: "",

        name: "The Greatest Train Robbery",
        providerName: "Red Tiger",
      },
      TheWildHatter: {
        redirectUrl: "/casino/ezugi/TheWildHatter",
        code: "1100174                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/The-Wild-Hatter.jpg",
        alt: "",
        name: "The Wild Hatter",
        providerName: "Red Tiger",
      },
      ThorLightning: {
        redirectUrl: "/casino/ezugi/ThorLightning",
        code: "1100175                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Thor`s-Lightning.jpg",
        alt: "",
        name: "Thor`s Lightning",
        providerName: "Red Tiger",
      },
      TikiFruits: {
        redirectUrl: "/casino/ezugi/TikiFruits",
        code: "1100176                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Tiki-Fruits.jpg",
        alt: "",
        name: "Tiki Fruits",
        providerName: "Red Tiger",
      },
      TotemLightning: {
        redirectUrl: "/casino/ezugi/TotemLightning",
        code: "1100177                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Totem-Lightning.jpg",
        alt: "",
        name: "Totem Lightning",
        providerName: "Red Tiger",
      },
      VaultCracker: {
        redirectUrl: "/casino/ezugi/VaultCracker",
        code: "1100178                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Vault-Cracker.jpg",
        alt: "",
        name: "Vault Cracker",
        providerName: "Red Tiger",
      },
      VaultofAnubis: {
        redirectUrl: "/casino/ezugi/VaultofAnubis",
        code: "1100179                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Vault-of-Anubis.jpg",
        alt: "",
        name: "Vault of Anubis",
        providerName: "Red Tiger",
      },
      WellofWishes: {
        redirectUrl: "/casino/ezugi/WellofWishes",
        code: "1100180                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Well-of-Wishes.jpg",
        alt: "",
        name: "Well of Wishes",
        providerName: "Red Tiger",
      },
      WildCatsMultiline: {
        redirectUrl: "/casino/ezugi/WildCatsMultiline",
        code: "1100181                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Cats-Multiline.jpg",
        alt: "",
        name: "Wild Cats Multiline",
        providerName: "Red Tiger",
      },
      WildOClock: {
        redirectUrl: "/casino/ezugi/WildOClock",
        code: "1100182                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-O`Clock.jpg",
        alt: "",
        name: "Wild O`Clock",
        providerName: "Red Tiger",
      },
      WildChest: {
        redirectUrl: "/casino/ezugi/WildChest",
        code: "1100183                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Wild-Wild-Chest.jpg",
        alt: "",
        name: "Wild Wild Chest",
        providerName: "Red Tiger",
      },
      WinEscalator: {
        redirectUrl: "/casino/ezugi/WinEscalator",
        code: "1100184                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Win-Escalator.jpg",
        alt: "",
        name: "Win Escalator",
        providerName: "Red Tiger",
      },
      YucatanMystery: {
        redirectUrl: "/casino/ezugi/YucatanMystery",
        code: "1100185                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/slots/Yucatan`s-Mystery.jpg",
        alt: "",
        name: "Yucatan Mystery",
        providerName: "Red Tiger",
      },
    },

    name: "Slots",
  },
  netenttab: {
    slide1: {
      asgardianstones: {
        redirectUrl: "/casino/ezgne-asgardian-stones",
        code: "1100096",
        casino: "ezugi",
        imgUrl: "./images/slots/asgardianstones.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Asgardian Stones",
        providerName: "NetEnt",
      },
      secrets: {
        redirectUrl: "/casino/ezgne-secrets-of-atlantis",
        code: "1100106",
        casino: "ezugi",
        imgUrl: "./images/slots/secrets-of-atlantis.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Secrets of Atlantis",
        providerName: "NetEnt",
      },
      SteamTower: {
        redirectUrl: "/casino/ezgne-steam-tower",
        code: "1100043",
        casino: "ezugi",
        imgUrl: "./images/slots/Steam-Tower.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Steam Tower",
        providerName: "NetEnt",
      },
      DivinieFortuneMegaways: {
        redirectUrl: "/casino/ezgne-divine-fortune-megaways",
        code: "1100089",
        casino: "ezugi",
        imgUrl: "./images/slots/divine_fortune_megaways.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Divine Fortune Megaways",
        providerName: "NetEnt",
      },
      FruitShopMegaways: {
        redirectUrl: "/casino/ezgne-fruit-shop-megaways",
        code: "1100094",
        casino: "ezugi",
        imgUrl: "./images/slots/Fruit_Shop_Megaways.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Fruit Shop Megaways",
        providerName: "NetEnt",
      },
      GorillaKingdom: {
        redirectUrl: "/casino/ezgne-gorilla-kingdom",
        code: "1100088",
        casino: "ezugi",
        imgUrl: "./images/slots/Gorilla_Kingdom.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Gorilla Kingdom",
        providerName: "NetEnt",
      },
      ReelKingMegaways: {
        redirectUrl: "/casino/ezgrt-reel-king-mega",
        code: "1100052",
        casino: "ezugi",
        imgUrl: "./images/slots/Reel_King_Mega.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Reel King Mega",
        providerName: "NetEnt",
      },
      Christmas: {
        redirectUrl: "/casino/ezgne-aloha-christmas",
        code: "1100032",
        casino: "ezugi",
        imgUrl: "./images/slots/Aloha-Christmas.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Aloha! Christmas",
        providerName: "NetEnt",
      },
      ClusterPays: {
        redirectUrl: "/casino/ezgne-aloha-cluster-pays",
        code: "1100033",
        casino: "ezugi",
        imgUrl: "./images/slots/Aloha-Cluster-Pays.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Aloha! Cluster Pays",
        providerName: "NetEnt",
      },
      WildWest: {
        redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
        code: "1100038",
        casino: "ezugi",
        imgUrl: "./images/slots/Wild-Wild-West-The-Great-Train-Heist.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Wild Wild West: The Great Train Heist",
        providerName: "NetEnt",
      },
      TwinSpinMegaways: {
        redirectUrl: "/casino/ezgne-twin-spin-megaways",
        code: "1100039",
        casino: "ezugi",
        imgUrl: "./images/slots/Twin_Spin_Megaways.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Twin Spin Megaways",
        providerName: "NetEnt",
      },
      TurnFortune: {
        redirectUrl: "/casino/ezgne-turn-your-fortune",
        code: "1100041",
        casino: "ezugi",
        imgUrl: "./images/slots/Turn_Your_Fortune.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Turn Your Fortune",
        providerName: "NetEnt",
      },
    },
    slide2: {
      Pyramid: {
        redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
        code: "1100078",
        casino: "ezugi",
        imgUrl: "./images/slots/Pyramid-Quest-for-Immortality.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Pyramid: Quest for Immortality",
        providerName: "NetEnt",
      },
      PiggyRiches: {
        redirectUrl: "/casino/ezgne-piggy-riches",
        code: "1100080",
        casino: "ezugi",
        imgUrl: "./images/slots/Piggy-Riches.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Piggy Riches",
      },
      DarkKing: {
        redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
        code: "1100081",
        casino: "ezugi",
        imgUrl: "./images/slots/Dark-King-Forbidden-Riches.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dark King: Forbidden Riches",
        providerName: "NetEnt",
      },
      JingleSpin: {
        redirectUrl: "/casino/ezgne-jingle-spin",
        code: "1100082",
        casino: "ezugi",
        imgUrl: "./images/slots/Jingle-Spin.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Jingle Spin",
        providerName: "NetEnt",
      },
      JackHammer: {
        redirectUrl: "/casino/ezgne-jack-hammer",
        code: "1100084",
        casino: "ezugi",
        imgUrl: "./images/slots/Jack-Hammer.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Jack Hammer",
        providerName: "NetEnt",
      },
      DeadorAlive: {
        redirectUrl: "/casino/ezgne-dead-or-alive",
        code: "1100085",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dead or Alive",
        providerName: "NetEnt",
      },
      DeadorAlive2: {
        redirectUrl: "/casino/ezgne-dead-or-alive-2",
        code: "1100087",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive-2.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dead or Alive 2",
        providerName: "NetEnt",
      },
      JackandtheBeanstalk: {
        redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
        code: "1100086",
        casino: "ezugi",
        imgUrl: "./images/slots/Jack-and-the-Beanstalk.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Jack and the Beanstalk",
        providerName: "NetEnt",
      },
      Elements: {
        redirectUrl: "/casino/ezgne-elements-the-awakening",
        code: "1100091",
        casino: "ezugi",
        imgUrl: "./images/slots/Elements-The-Awakening.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Elements: The Awakening",
        providerName: "NetEnt",
      },
      FinnandtheSwirlySpin: {
        redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
        code: "1100093",
        casino: "ezugi",
        imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Finn and the Swirly Spin",
        providerName: "NetEnt",
      },
      FruitShop: {
        redirectUrl: "/casino/ezgne-fruit-shop",
        code: "1100095",
        casino: "ezugi",
        imgUrl: "./images/slots/Fruit-Shop.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Fruit Shop",
        providerName: "NetEnt",
      },
      DeadorAlive2FeatureBuy: {
        redirectUrl: "/casino/ezugi/DeadorAlive2FeatureBuy",
        code: "1100100",
        casino: "ezugi",
        imgUrl: "./images/slots/Dead-or-Alive-2-Feature-Buy.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dead or Alive 2 Feature Buy",
        providerName: "NetEnt",
      },
    },

    name: "Netent",
    key: "netent",
  },
  redtigertab: {
    slide1: {
      NinjaWays: {
        redirectUrl: "/casino/ezgrt-ninja-ways",
        code: "1100166",
        casino: "ezugi",
        imgUrl: "./images/slots/Ninja-Ways.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Ninja Ways",
        providerName: "Red Tiger",
      },
      PathofDestiny: {
        redirectUrl: "/casino/ezgrt-path-of-destiny",
        code: "1100167",
        casino: "ezugi",
        imgUrl: "./images/slots/Path-of-Destiny.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Path of Destiny",
        providerName: "Red Tiger",
      },
      PersianFortune: {
        redirectUrl: "/casino/ezgrt-persian-fortune",
        code: "1100168",
        casino: "ezugi",
        imgUrl: "./images/slots/Persian-Fortune.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Persian Fortune",
        providerName: "Red Tiger",
      },
      ReelHeist: {
        redirectUrl: "/casino/ezgrt-reel-heist",
        code: "1100169",
        casino: "ezugi",
        imgUrl: "./images/slots/Reel-Heist.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Reel Heist",
        providerName: "Red Tiger",
      },
      RobinHoodWildForest: {
        redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
        code: "1100170",
        casino: "ezugi",
        imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Robin Hood`s Wild Forest",
        providerName: "Red Tiger",
      },
      SnowWild: {
        redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
        code: "1100171",
        casino: "ezugi",
        imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Snow Wild And The 7 Features",
        providerName: "Red Tiger",
      },
      SylvanSpirits: {
        redirectUrl: "/casino/ezgrt-sylvan-spirits",
        code: "1100172",
        casino: "ezugi",
        imgUrl: "./images/slots/Sylvan-Spirits.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Sylvan Spirits",
        providerName: "Red Tiger",
      },
      TheGreatestTrainRobbery: {
        redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
        code: "1100173",
        casino: "ezugi",
        imgUrl: "./images/slots/The-Greatest-Train-Robbery.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "The Greatest Train Robbery",
        providerName: "Red Tiger",
      },
      TheWildHatter: {
        redirectUrl: "/casino/ezgrt-the-wild-hatter",
        code: "1100174",
        casino: "ezugi",
        imgUrl: "./images/slots/The-Wild-Hatter.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "The Wild Hatter",
        providerName: "Red Tiger",
      },
      ThorLightning: {
        redirectUrl: "/casino/ezgrt-thors-lightning",
        code: "1100175",
        casino: "ezugi",
        imgUrl: "./images/slots/Thor`s-Lightning.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Thor`s Lightning",
        providerName: "Red Tiger",
      },
      DragonLuck: {
        redirectUrl: "/casino/ezgrt-dragons-luck",
        code: "1100001",
        casino: "ezugi",
        imgUrl: "./images/slots/Dragon's-Luck.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dragon's Luck",
        providerName: "Red Tiger",
      },
      DragonLuckReel: {
        redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
        code: "1100002",
        casino: "ezugi",
        imgUrl: "./images/slots/Dragon's-Luck-Power-Reels.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dragon's Luck Power Reels",
        providerName: "Red Tiger",
      },
    },
    slide2: {
      TikiFruits: {
        redirectUrl: "/casino/ezgrt-tiki-fruits",
        code: "1100176",
        casino: "ezugi",
        imgUrl: "./images/slots/Tiki-Fruits.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Tiki Fruits",
        providerName: "Red Tiger",
      },
      TotemLightning: {
        redirectUrl: "/casino/ezgrt-totem-lightning",
        code: "1100177",
        casino: "ezugi",
        imgUrl: "./images/slots/Totem-Lightning.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Totem Lightning",
        providerName: "Red Tiger",
      },
      VaultCracker: {
        redirectUrl: "/casino/ezgrt-vault-cracker",
        code: "1100178",
        casino: "ezugi",
        imgUrl: "./images/slots/Vault-Cracker.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Vault Cracker",
        providerName: "Red Tiger",
      },
      VaultofAnubis: {
        redirectUrl: "/casino/ezgrt-vault-of-anubis",
        code: "1100179",
        casino: "ezugi",
        imgUrl: "./images/slots/Vault-of-Anubis.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Vault of Anubis",
        providerName: "Red Tiger",
      },
      WellofWishes: {
        redirectUrl: "/casino/ezgrt-well-of-wishes",
        code: "1100180",
        casino: "ezugi",
        imgUrl: "./images/slots/Well-of-Wishes.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Well of Wishes",
        providerName: "Red Tiger",
      },

      WildCatsMultiline: {
        redirectUrl: "/casino/ezgrt-wild-cats-multiline",
        code: "1100181",
        casino: "ezugi",
        imgUrl: "./images/slots/Wild-Cats-Multiline.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Wild Cats Multiline",
        providerName: "Red Tiger",
      },
      WildOClock: {
        redirectUrl: "/casino/ezgrt-wild-oclock",
        code: "1100182",
        casino: "ezugi",
        imgUrl: "./images/slots/Wild-O`Clock.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Wild O`Clock",
        providerName: "Red Tiger",
      },
      WildChest: {
        redirectUrl: "/casino/ezgrt-wild-wild-chest",
        code: "1100183",
        casino: "ezugi",
        imgUrl: "./images/slots/Wild-Wild-Chest.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Wild Wild Chest",
        providerName: "Red Tiger",
      },
      WinEscalator: {
        redirectUrl: "/casino/ezgrt-win-escalator",
        code: "1100184",
        casino: "ezugi",
        imgUrl: "./images/slots/Win-Escalator.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Win Escalator",
        providerName: "Red Tiger",
      },
      YucatanMystery: {
        redirectUrl: "/casino/ezgrt-yucatans-mystery",
        code: "1100185",
        casino: "ezugi",
        imgUrl: "./images/slots/Yucatan`s-Mystery.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Yucatan`s Mystery",
        providerName: "Red Tiger",
      },
      DragonFire: {
        redirectUrl: "/casino/ezgrt-dragons-fire",
        code: "1100008",
        casino: "ezugi",
        imgUrl: "./images/slots/Dragon's-Fire.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dragon's Fire",
        providerName: "Red Tiger",
      },
      DragonLuckDeluxe: {
        redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
        code: "1100011",
        casino: "ezugi",
        imgUrl: "./images/slots/Dragon's-Luck-Deluxe.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dragon's Luck Deluxe",
        providerName: "Red Tiger",
      },
    },
    name: "Red Tiger",
    key: "redTiger",
  },
  providers: {
    slide1: {
      evolution: {
        redirectUrl: "/casino/evolution",
        code: "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        cover: { src: "./images/provider/new/Evo.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Evolution.jpg",
        alt: "",
        name: "Evolution",
        providerName: "Evolution",
      },
      ezugi: {
        redirectUrl: "/casino/ezugi",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        cover: { src: "./images/provider/new/Ezugi.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Ezugi.jpg",
        alt: "",
        name: "Ezugi",
        providerName: "Ezugi",
      },
      supernowa: {
        redirectUrl: "/casino/supernowa",
        code: "",
        casino: "wco",
        provider: "SN",
        homeUrl: "",
        cover: { src: "./images/provider/new/Supernowa.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Supernowa.jpg",
        alt: "",
        games: {},
        name: "Supernowa",
        providerName: "Supernowa",
      },
      worldcasino: {
        redirectUrl: "/casino/worldcasino",
        code: "",
        casino: "wco",
        provider: "",
        homeUrl: "",
        cover: { src: "./images/provider/new/WorldCasino.png", alt: "" },
        imgUrl: "./images/provider/slotspage/WorldCasino.jpg",
        alt: "",
        games: {},
        name: "World Casino",
        providerName: "World Casino",
      },
      xpg: {
        redirectUrl: "/casino/xpg",
        code: "",
        casino: "wco",
        provider: "XPG",
        homeUrl: "",
        cover: { src: "./images/provider/new/Xpg.png", alt: "" },
        imgUrl: "./images/provider/slotspage/XPG.jpg",
        alt: "",
        games: {},
        name: "XPG",
        providerName: "XPG",
      },
      // onetouch: {
      //   redirectUrl: "/casino/onetouch",
      //   code: "",
      //   casino: "wco",
      //   provider: "OT",
      //   homeUrl: "",
      //   cover: { src: "./images/provider/new/OneTouch.png", alt: "" },
      //   imgUrl: "./images/provider/slotspage/OneTouch.jpg",
      //   alt: "",
      //   games: {},
      //   name: "One Touch",
      //   providerName: "One Touch",
      // },
      onlyplay: {
        redirectUrl: "/casino/onlyplay",
        code: "",
        casino: "wco",
        provider: "GT",
        homeUrl: "",
        cover: { src: "./images/provider/new/OnlyPlay.png", alt: "" },
        imgUrl: "./images/provider/slotspage/OnlyPlay.jpg",
        alt: "",
        games: {},
        name: "Only Play",
        providerName: "Only Play",
      },
      pragmaticplay: {
        redirectUrl: "/casino/pragmaticplay",
        code: "",
        casino: "wco",
        provider: "PP",
        homeUrl: "",
        cover: { src: "./images/provider/new/Pragamatic.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Pragamatic.jpg",
        alt: "",
        games: {},
        name: "Pragmatic Play",
        providerName: "Pragmatic Play",
      },
      qtech: {
        redirectUrl: "/casino/qtech",
        code: "",
        casino: "wco",
        provider: "QT",
        homeUrl: "",
        cover: { src: "./images/provider/new/Qtech.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Qtech.jpg",
        alt: "",
        games: {},
        name: "Qtech",
        providerName: "Qtech",
      },
      vivo: {
        redirectUrl: "/casino/vivo",
        code: "vivo",
        casino: "vivo",
        provider: "",
        homeUrl: "",
        cover: { src: "./images/provider/new/Vivo.png", alt: "" },
        imgUrl: "./images/provider/slotspage/Vivo.jpg",
        name: "Vivo Gaming",
        providerName: "Vivo",
      },
    },

    name: "Providers",
  },
  Topgametabs: {
    slide1: {
      CrazyTimeEvolution: {
        redirectUrl: "/casino/ezgevo-crazy-time",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/CrazyTime.jpg",
        alt: "",
        name: "Crazy Time",
        providerName: "Evolution",
      },
      LightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/LightningRoulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      TurkishLightningRouletteEvolution: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/TurkishLightningRulet.jpg",
        alt: "",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
      MegaballEvolution: {
        redirectUrl: "/casino/ezgevo-mega-ball",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/Megaball.jpg",
        alt: "",
        name: "Megaball",
        providerName: "Evolution",
      },
      SuperSicoboEvolution: {
        redirectUrl: "/casino/ezgevo-super-sic-bo",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/SuperSicBo.jpg",
        alt: "",
        name: "Super Sicbo",
        providerName: "Evolution",
      },
      LightningDiceEvolution: {
        redirectUrl: "/casino/ezgevo-lightning-dice",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/LightningDice.jpg",
        alt: "",
        name: "Lightning Dice",
        providerName: "Evolution",
      },
      DreamCatcherEvolution: {
        redirectUrl: "/casino/ezgevo-dream-catcher",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/DreamCatcher.jpg",
        alt: "",
        name: "Dream Catcher",
        providerName: "Evolution",
      },
      StockMarketEvolution: {
        redirectUrl: "/casino/ezgevo-stock-market",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/stockmarket.jpg",
        alt: "",
        name: "Stock Market",
        providerName: "Evolution",
      },
      SpeedBaccaratAEvolution: {
        redirectUrl: "/casino/ezgevo-speed-baccarat-a",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/SpeedBaccaratA.jpg",
        alt: "",
        name: "Speed Baccarat A",
        providerName: "Evolution",
      },
      BacboEvolution: {
        redirectUrl: "/casino/ezgevo-bac-bo",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/bacbo.jpg",
        alt: "",
        name: "Bac Bo",
        providerName: "Evolution",
      },
      ExtraChilliEpicSpinsEvolution: {
        redirectUrl: "/casino/ezgevo-extra-chilli-epic-spins",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/ExtraChilliEpicSpins.jpg",
        alt: "",
        name: "Extra Chilli Epic Spins",
        providerName: "Evolution",
      },
      DeadorAliveEvolution: {
        redirectUrl: "/casino/ezgevo-dead-or-alive-saloon",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/SpeedBaccaratA.jpg",
        alt: "",
        name: "Dead or Alive: Saloon",
        providerName: "Evolution",
      },
      GonzoTreasureHuntEvolution: {
        redirectUrl: "/casino/ezgevo-gonzos-treasure-hunt",
        code: "1000112",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/topgames/evolution/SpeedBaccaratA.jpg",
        alt: "",
        name: "Gonzo's Treasure Hunt",
        providerName: "Evolution",
      },
    },
    name: "Top Games",
    key: "Topgames",
  },
};
